export const dummyDataClient=[
    {
        "Sr.No": 1,
        "Position received date": "22-Nov-24",
        "Clarity call date": "22-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Dec-24",
        "Candidate Date of selection": "10-Feb-25",
        "Revised Target Date of Selection": "07-Dec-24",
        "Reason of delay/HOLD": "1. Its a Niche Skill. 2. Shared 12 Profiles and all got rejected. 3 Conducted 4 Sourcing calls with HM. 4 Had a call with Sakshi and Sunil took some deviation then shared 6 More Profiles .",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-Dec-24",
        "Actual Offer date": "12-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "10-Mar-25",
        "Actual DOJ candidate will join": "12-May-25",
        "Client": "John Deere",
        "HR name/HM": "Sachin Ekal",
        "Position Name": "PV&V Engineer-G6",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "17 LPA",
        "Billable CTC": 1550000,
        "Commercial %": 0.07,
        "Billing amount per position": 108500.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 108500.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Varsha",
        "Selected candidate name": "Sandeep Chauhan",
        "Recruiter name": "Varsha"
    },
    {
        "Sr.No": 2,
        "Position received date": "24-Jan-25",
        "Clarity call date": "24-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "HM on Vacation for 10 Days ",
        "Select to offer TAT": 3,
        "Approx Offer date": "11-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "12-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Ashish",
        "Position Name": "Facility & Maintenance- G7",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "21 LPA",
        "Billable CTC": 1900000,
        "Commercial %": 0.07,
        "Billing amount per position": 133000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 133000,
        "Status": "Active",
        "Current delivery update": "1 L2 done-on Hold Antariksh- 3 L1 inline- High CTC",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Varsha",
        "Recruiter name": "Varsha"
    },
    {
        "Sr.No": 3,
        "Position received date": "27-Sep-24",
        "Clarity call date": "27-Sep-24",
        "Position renew date": "28-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Feb-25",
        "Candidate Date of selection": "04-Mar-25",
        "Revised Target Date of Selection": "12-Feb-25",
        "Reason of delay/HOLD": "Position is tricky",
        "Select to offer TAT": 3,
        "Approx Offer date": "15-Feb-25",
        "Actual Offer date": "07-Mar-25",
        "Official Notice Period": 90,
        "Approx DOJ": "16-May-25",
        "Actual DOJ candidate will join": "09-Jun-25",
        "Client": "John Deere",
        "HR name/HM": "Mangesh Deshpande",
        "Position Name": "Maintenance- G6",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "16 LPA",
        "Billable CTC": 1450000,
        "Commercial %": 0.07,
        "Billing amount per position": 101500.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 101500.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Varsha",
        "Selected candidate name": "Nitin Hadke",
        "Recruiter name": "Varsha"
    },
    {
        "Sr.No": 4,
        "Position received date": "30-Dec-24",
        "Clarity call date": "30-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-25",
        "Candidate Date of selection": "10-Jan-25",
        "Revised Target Date of Selection": "14-Jan-25",
        "Reason of delay/HOLD": "No delay",
        "Select to offer TAT": 3,
        "Approx Offer date": "17-Jan-25",
        "Actual Offer date": "16-Jan-25",
        "Official Notice Period": 30,
        "Approx DOJ": "16-Feb-25",
        "Actual DOJ candidate will join": "17-Feb-25",
        "Client": "John Deere",
        "HR name/HM": "Nagesh Chaudhary",
        "Position Name": "Application Engineer- G7",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "27 LPA",
        "Billable CTC": 2350345,
        "Commercial %": 0.07,
        "Billing amount per position": 164524.15000000002,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 164524.15000000002,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Varsha",
        "Selected candidate name": "Omkar Balwant Patil",
        "Recruiter name": "Varsha"
    },
    {
        "Sr.No": 5,
        "Position received date": "02-Jan-25",
        "Clarity call date": "02-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "17-Jan-25",
        "Candidate Date of selection": "23-Jan-25",
        "Revised Target Date of Selection": "17-Jan-25",
        "Reason of delay/HOLD": "1. 7 Days delay in feedback from HM",
        "Select to offer TAT": 3,
        "Approx Offer date": "20-Jan-25",
        "Actual Offer date": "27-Jan-25",
        "Official Notice Period": 30,
        "Approx DOJ": "19-Feb-25",
        "Actual DOJ candidate will join": "24-Feb-25",
        "Client": "John Deere",
        "HR name/HM": "Arvind Rai",
        "Position Name": "Packaging Design - G6",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "17 LPA",
        "Billable CTC": 1500810.7,
        "Commercial %": 0.07,
        "Billing amount per position": 105056.74900000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 105056.74900000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Varsha",
        "Selected candidate name": "Dinesh Rohidas Chaudhari",
        "Recruiter name": "Varsha"
    },
    {
        "Sr.No": 6,
        "Position received date": "13-Jan-25",
        "Clarity call date": "13-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "28-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "31-Jan-25",
        "Official Notice Period": 90,
        "Approx DOJ": "01-May-25",
        "Client": "John Deere",
        "HR name/HM": "Shrirang Phate/ Chandra shekhar Barai",
        "Position Name": "MBSD VSA Engineer- G7",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "32 LPA",
        "Billable CTC": 3000000,
        "Commercial %": 0.07,
        "Billing amount per position": 210000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 210000.00000000003,
        "Status": "Active",
        "Current delivery update": "1 L2 done - rejected, 1 CV feedback Pending",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Varsha",
        "Recruiter name": "Varsha"
    },
    {
        "Sr.No": 7,
        "Position received date": "17-Jan-25",
        "Clarity call date": "17-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "1 month delay from HM since 6th feb'24",
        "Select to offer TAT": 3,
        "Approx Offer date": "04-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "05-May-25",
        "Client": "John Deere",
        "HR name/HM": "Kedar Bahirat",
        "Position Name": "Sr Engineer- G6 VEVI",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "17 LPA",
        "Billable CTC": 1550000,
        "Commercial %": 0.07,
        "Billing amount per position": 108500.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 0.75,
        "Business Ensurity (actual revenue)": 81375.00000000001,
        "Status": "Active",
        "Current delivery update": "1 L2 inline- 20th March'25,",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Varsha",
        "Recruiter name": "Varsha"
    },
    {
        "Sr.No": 8,
        "Position received date": "18-Feb-25",
        "Clarity call date": "18-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "05-Mar-25",
        "Candidate Date of selection": "10-Mar-25",
        "Revised Target Date of Selection": "05-Mar-25",
        "Reason of delay/HOLD": "No delay, 1 L2 candidate rejected",
        "Select to offer TAT": 3,
        "Approx Offer date": "08-Mar-25",
        "Actual Offer date": "13-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "06-Jun-25",
        "Actual DOJ candidate will join": "16-Jun-25",
        "Client": "John Deere",
        "HR name/HM": "Srikanta Nahak",
        "Position Name": "Mechanical Design Engineer-G6",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "19 LPA",
        "Billable CTC": 1800000,
        "Commercial %": 0.07,
        "Billing amount per position": 126000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 126000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Varsha",
        "Selected candidate name": "Jay Mehta",
        "Recruiter name": "Varsha"
    },
    {
        "Sr.No": 9,
        "Position received date": "25-Feb-25",
        "Clarity call date": "26-Feb-25",
        "Position renew date": "10-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-Mar-25",
        "Candidate Date of selection": "25-Apr-25",
        "Revised Target Date of Selection": "13-Mar-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "16-Mar-25",
        "Actual Offer date": "28-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "15-May-25",
        "Actual DOJ candidate will join": "14-Jul-25",
        "Client": "John Deere",
        "HR name/HM": "Sanjeev Hallale",
        "Position Name": "Structural Optimization-G7",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "28 LPA",
        "Billable CTC": 2600000,
        "Commercial %": 0.07,
        "Billing amount per position": 182000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 182000.00000000003,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Varsha/Charul Sharma",
        "Selected candidate name": "Himanshu Mangroliya",
        "Recruiter name": "Varsha/Charul"
    },
    {
        "Sr.No": 10,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "10-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position closed internally",
        "Select to offer TAT": 7,
        "Approx Offer date": "01-Feb-25",
        "Official Notice Period": 30,
        "Approx DOJ": "03-Mar-25",
        "Client": "Endurance ",
        "HR name/HM": "Shalini",
        "Position Name": "AM/DM Internal Audit",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 LPA",
        "Billable CTC": 1350000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 11,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "10-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Jan-25",
        "Candidate Date of selection": "14-Jan-25",
        "Revised Target Date of Selection": "25-Jan-25",
        "Reason of delay/HOLD": "Position was not very clear in the initial call and then we have arrnages the hiring manager call on 10th Jan and within 1 day of deliver we have closed this role",
        "Select to offer TAT": 5,
        "Approx Offer date": "30-Jan-25",
        "Actual Offer date": "21-Jan-25",
        "Official Notice Period": 90,
        "Approx DOJ": "30-Apr-25",
        "Actual DOJ candidate will join": "07-Apr-25",
        "Client": "Endurance ",
        "HR name/HM": "Shalini",
        "Position Name": "SM - Corporate Internal Audit",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1400000,
        "Commercial %": 0.0833,
        "Billing amount per position": 116620,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 116620,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Selected candidate name": "Rakesh Kumar Choudhury",
        "Recruiter name": "Anand"
    },
    {
        "Sr.No": 12,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "10-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position closed internally",
        "Select to offer TAT": 7,
        "Approx Offer date": "01-Feb-25",
        "Official Notice Period": 30,
        "Approx DOJ": "03-Mar-25",
        "Client": "Endurance ",
        "HR name/HM": "Shalini",
        "Position Name": "AM/DM Internal Audit",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 LPA",
        "Billable CTC": 1350000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 13,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "10-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position closed internally",
        "Select to offer TAT": 7,
        "Approx Offer date": "01-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "02-May-25",
        "Client": "Endurance ",
        "HR name/HM": "Shalini",
        "Position Name": "AGM- Corporate Internal Audit",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "30 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 14,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "10-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position is tricky , they need hardcore ABS candidates ",
        "Select to offer TAT": 7,
        "Approx Offer date": "01-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "02-May-25",
        "Client": "Endurance ",
        "HR name/HM": "Shital Janjal",
        "Position Name": "Section Head Design & Development - ABS",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "30 LPA",
        "Billable CTC": 2800000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 15,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Dec-24",
        "Approx DOJ": "09-Dec-24",
        "Client": "Endurance ",
        "HR name/HM": "Shital",
        "Position Name": "Program Manager- M4",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "30 LPA",
        "Billable CTC": 270000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Varsha"
    },
    {
        "Sr.No": 16,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "13-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "28-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "they are offering less ctc and looking candidates who are having hardcore brake design expereince",
        "Select to offer TAT": 7,
        "Approx Offer date": "04-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "05-May-25",
        "Client": "Endurance ",
        "HR name/HM": "Shital Janjal",
        "Position Name": "Brake Design ",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "11 LPA",
        "Billable CTC": 800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 17,
        "Position received date": "10-Nov-24",
        "Clarity call date": "13-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "28-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "31-Dec-24",
        "Official Notice Period": 30,
        "Approx DOJ": "30-Jan-25",
        "Client": "John Deere",
        "HR name/HM": "Prashanth Pandey",
        "Position Name": "(109647, 109823, 109829) Emb C/QT - G6",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Shruti Gupta"
    },
    {
        "Sr.No": 19,
        "Position received date": "24-Dec-24",
        "Clarity call date": "24-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-Jan-25",
        "Candidate Date of selection": "06-Feb-25",
        "Revised Target Date of Selection": "08-Jan-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "11-Jan-25",
        "Actual Offer date": "11-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "12-Mar-25",
        "Actual DOJ candidate will join": "17-Feb-25",
        "Client": "John Deere",
        "HR name/HM": "Chetana Wasnik",
        "Position Name": "EMB C/ MATLAB developer - G6(110224)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "18 LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.07,
        "Billing amount per position": 105000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 105000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Jindal",
        "Selected candidate name": "B Aravind",
        "Recruiter name": "Mohan"
    },
    {
        "Sr.No": 20,
        "Position received date": "25-Oct-24",
        "Clarity call date": "26-Oct-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Nov-24",
        "Candidate Date of selection": "06-Jan-25",
        "Revised Target Date of Selection": "10-Nov-24",
        "Select to offer TAT": 3,
        "Approx Offer date": "13-Nov-24",
        "Actual Offer date": "09-Jan-25",
        "Official Notice Period": 90,
        "Approx DOJ": "11-Feb-25",
        "Actual DOJ candidate will join": "14-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Vishal Rane",
        "Position Name": "Lead Engineer(108718)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2450000,
        "Billable CTC": 2000000,
        "Commercial %": 0.07,
        "Billing amount per position": 140000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 140000,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Athul K",
        "Recruiter name": "sriram"
    },
    {
        "Sr.No": 21,
        "Position received date": "18-Nov-24",
        "Clarity call date": "19-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Candidate Date of selection": "24-Feb-25",
        "Revised Target Date of Selection": "04-Dec-24",
        "Reason of delay/HOLD": "Rejections on skills required",
        "Select to offer TAT": 3,
        "Approx Offer date": "07-Dec-24",
        "Actual Offer date": "10-Mar-25",
        "Official Notice Period": 90,
        "Approx DOJ": "07-Mar-25",
        "Actual DOJ candidate will join": "30th-June-25",
        "Client": "John Deere",
        "HR name/HM": "Kedar",
        "Position Name": "(109886) Autmation Engineer (Backend Engineer ) - G7",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2450000,
        "Billable CTC": 2000000,
        "Commercial %": 0.07,
        "Billing amount per position": 140000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 140000,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Ambrish ambrendar pandey",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 22,
        "Position received date": "18-Dec-24",
        "Clarity call date": "19-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "03-Jan-25",
        "Candidate Date of selection": "28-Jan-25",
        "Revised Target Date of Selection": "03-Jan-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "06-Jan-25",
        "Actual Offer date": "31-Jan-25",
        "Official Notice Period": 60,
        "Approx DOJ": "07-Mar-25",
        "Actual DOJ candidate will join": "10-Feb-25",
        "Client": "John Deere",
        "HR name/HM": "Vishal Rane",
        "Position Name": "(109647) Sr Engineer (CVML - G6)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1500000,
        "Commercial %": 0.07,
        "Billing amount per position": 105000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 105000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Akshay Kasar",
        "Recruiter name": "sriram"
    },
    {
        "Sr.No": 23,
        "Position received date": "15-Oct-24",
        "Clarity call date": "16-Oct-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "31-Oct-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "03-Nov-24",
        "Official Notice Period": 90,
        "Approx DOJ": "01-Feb-25",
        "Client": "John Deere",
        "HR name/HM": "Vishal Rane",
        "Position Name": "(111401) Lead Engineer - ML G7)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "24.5 PA",
        "Billable CTC": 2000000,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "Additional skill set is reuired",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 24,
        "Position received date": "22-Aug-24",
        "Clarity call date": "22-Aug-24",
        "Position renew date": "19-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Due to delay and duplicity Mam said to hold on this client",
        "Select to offer TAT": 5,
        "Approx Offer date": "11-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "10-Apr-25",
        "Client": "ICRA",
        "HR name/HM": "Liza Paul",
        "Position Name": "Full Stack Java Developer (Senior)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15LPA",
        "Billable CTC": 1350000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 25,
        "Position received date": "22-Aug-24",
        "Clarity call date": "22-Aug-24",
        "Position renew date": "19-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Due to delay and duplicity Mam said to hold on this client",
        "Select to offer TAT": 5,
        "Approx Offer date": "11-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "10-May-25",
        "Client": "ICRA",
        "HR name/HM": "Amitava Roy ",
        "Position Name": "Senior Associate Developer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15LPA",
        "Billable CTC": 1350000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 26,
        "Position received date": "22-Aug-24",
        "Clarity call date": "22-Aug-24",
        "Position renew date": "19-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Due to delay and duplicity Mam said to hold on this client",
        "Select to offer TAT": 5,
        "Approx Offer date": "11-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "10-May-25",
        "Client": "ICRA",
        "HR name/HM": "Liza Paul",
        "Position Name": "Principal Programmer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "20 LPA",
        "Billable CTC": 1800000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 27,
        "Position received date": "22-Nov-24",
        "Clarity call date": "22-Nov-24",
        "Position renew date": "07-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Internally movement or discussion going on",
        "Select to offer TAT": 5,
        "Approx Offer date": "27-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "28-Apr-25",
        "Client": "ICRA",
        "HR name/HM": "Puja Jaiswal",
        "Position Name": "Financial Analyst - SQL",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 LPA",
        "Billable CTC": 1200000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 28,
        "Position received date": "16-Oct-24",
        "Clarity call date": "16-Oct-24",
        "Position renew date": "07-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Internally movement or discussion going on",
        "Select to offer TAT": 5,
        "Approx Offer date": "27-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "28-Apr-25",
        "Client": "ICRA",
        "HR name/HM": "Amitava Roy ",
        "Position Name": "AM/DM Model Governance Stats",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "Up to 25 LPA",
        "Billable CTC": 200000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 29,
        "Position received date": "22-Aug-24",
        "Clarity call date": "22-Aug-24",
        "Position renew date": "19-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Due to delay and duplicity Mam said to hold on this client",
        "Select to offer TAT": 5,
        "Approx Offer date": "11-Mar-25",
        "Official Notice Period": 90,
        "Approx DOJ": "09-Jun-25",
        "Client": "ICRA",
        "HR name/HM": "Amitava Roy ",
        "Position Name": "Senior Architect",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "25 LPA",
        "Billable CTC": 2250000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 30,
        "Position received date": "30-Aug-24",
        "Clarity call date": "30-Aug-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Sep-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Internally movement or discussion going on",
        "Select to offer TAT": 5,
        "Approx Offer date": "19-Sep-24",
        "Official Notice Period": 90,
        "Approx DOJ": "18-Dec-24",
        "Client": "ICRA",
        "HR name/HM": "Amitava Roy ",
        "Position Name": "Sr. Manager/Manager Model Governance",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "30 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 31,
        "Position received date": "02-Dec-24",
        "Clarity call date": "02-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "17-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Internally movement or discussion going on",
        "Select to offer TAT": 5,
        "Approx Offer date": "22-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "22-Mar-25",
        "Client": "ICRA",
        "HR name/HM": "Amitava Roy ",
        "Position Name": "Business Analyst",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "20 to 25 LPA",
        "Billable CTC": 2000000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 32,
        "Position received date": "20-Nov-24",
        "Clarity call date": "20-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "05-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "10-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "10-Mar-25",
        "Client": "ICRA",
        "HR name/HM": "Amitava Roy ",
        "Position Name": "BFS Risk Analyst",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "30 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Shruti Jindal"
    },
    {
        "Sr.No": 33,
        "Position received date": "18-Oct-24",
        "Clarity call date": "18-Oct-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Nov-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "07-Nov-24",
        "Official Notice Period": 90,
        "Approx DOJ": "05-Feb-25",
        "Client": "ICRA",
        "HR name/HM": "Menka",
        "Position Name": "Mgr/Sr Mgr Customized research",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "30 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Shruti Jindal"
    },
    {
        "Sr.No": 34,
        "Position received date": "30-Aug-24",
        "Clarity call date": "30-Aug-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Sep-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "19-Sep-24",
        "Official Notice Period": 90,
        "Approx DOJ": "18-Dec-24",
        "Client": "ICRA",
        "HR name/HM": "Amitava Roy ",
        "Position Name": "SM/AVP/VP -  BFS Risk Solution & Analytics (ECL)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "Upto 40 LPA",
        "Billable CTC": 3500000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Shruti Jindal"
    },
    {
        "Sr.No": 35,
        "Position received date": "02-Dec-24",
        "Clarity call date": "02-Dec-24",
        "Position renew date": "19-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Due to delay and duplicity Mam said to hold on this client",
        "Select to offer TAT": 5,
        "Approx Offer date": "11-Mar-25",
        "Official Notice Period": 90,
        "Approx DOJ": "09-Jun-25",
        "Client": "ICRA",
        "HR name/HM": "Liza Paul",
        "Position Name": "AVP- Product Engineering",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "35 LPA",
        "Billable CTC": 3500000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 36,
        "Position received date": "02-Dec-24",
        "Clarity call date": "02-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "17-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Internally movement or discussion going on",
        "Select to offer TAT": 5,
        "Approx Offer date": "22-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "22-Mar-25",
        "Client": "ICRA",
        "HR name/HM": "Amitava Roy ",
        "Position Name": "Delivery Head/Sr. Delivery Manager - AVP - Kolkata",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "50 lpa",
        "Billable CTC": 4000000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 37,
        "Position received date": "09-May-24",
        "Clarity call date": "09-May-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "24-May-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "29-May-24",
        "Official Notice Period": 60,
        "Approx DOJ": "28-Jul-24",
        "Client": "L&T Defence",
        "HR name/HM": "Kalpesh",
        "Position Name": "C++ QT - TPC - Kalpesh",
        "Number of Positions": 5,
        "Current Active role": 0,
        "closed": 5,
        "Budget": "10 LPA",
        "Billable CTC": 800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 333200,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 333200,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Jindal",
        "Recruiter name": "Shruti Jindal"
    },
    {
        "Sr.No": 38,
        "Position received date": "20-Dec-24",
        "Clarity call date": "20-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Jan-25",
        "Official Notice Period": 90,
        "Approx DOJ": "09-Apr-25",
        "Client": "L&T Defence",
        "HR name/HM": "Kalpesh",
        "Position Name": "Software Developer - Embedded C RTOS Vxworks",
        "Number of Positions": 2,
        "Current Active role": 0,
        "closed": 2,
        "Budget": "10 LPA",
        "Billable CTC": 800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 133280,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 133280,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Jindal",
        "Recruiter name": "Shruti Jindal"
    },
    {
        "Sr.No": 39,
        "Position received date": "13-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "28-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Candidates are not giving the test on time and most of the candidates are getting rejected in the test",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Dec-24",
        "Official Notice Period": 60,
        "Approx DOJ": "07-Feb-25",
        "Client": "nVent",
        "HR name/HM": "Shifa",
        "Position Name": "Software Engineer/Software Developer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "10 - 15 LPA / 25 - 35 Lac PA",
        "Billable CTC": 1200000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 40,
        "Position received date": "13-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "28-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Candidates are not giving the test on time and most of the candidates are getting rejected in the test",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Dec-24",
        "Official Notice Period": 60,
        "Approx DOJ": "07-Feb-25",
        "Client": "nVent",
        "HR name/HM": "Shifa",
        "Position Name": "Software Engineer/Software Developer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "10 - 15 LPA / 25 - 35 Lac PA",
        "Billable CTC": 1200000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 41,
        "Position received date": "13-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "28-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Candidates are not giving the test on time and most of the candidates are getting rejected in the test",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Dec-24",
        "Official Notice Period": 60,
        "Approx DOJ": "07-Feb-25",
        "Client": "nVent",
        "HR name/HM": "Shifa",
        "Position Name": "Software Engineer/Software Developer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "10 - 15 LPA / 25 - 35 Lac PA",
        "Billable CTC": 1200000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 42,
        "Position received date": "13-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "28-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Candidates are not giving the test on time and most of the candidates are getting rejected in the test",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "09-Mar-25",
        "Client": "nVent",
        "HR name/HM": "Shifa",
        "Position Name": "Technical Lead – Embedded Systems",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "25 - 35 Lac PA",
        "Billable CTC": 2500000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 43,
        "Position received date": "13-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "28-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Candidates are not giving the test on time and most of the candidates are getting rejected in the test",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "09-Mar-25",
        "Client": "nVent",
        "HR name/HM": "Shifa",
        "Position Name": "Technical Lead – Embedded Systems",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "25 - 35 Lac PA",
        "Billable CTC": 2500000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 44,
        "Position received date": "13-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "28-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Candidates are not giving the test on time and most of the candidates are getting rejected in the test",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "09-Mar-25",
        "Client": "nVent",
        "HR name/HM": "Shifa",
        "Position Name": "Technical Architect - Embedded SW",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "25 - 35 Lac PA",
        "Billable CTC": 2500000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 45,
        "Position received date": "13-Nov-24",
        "Clarity call date": "19-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Someone identified from other sources",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "09-Mar-25",
        "Client": "nVent",
        "HR name/HM": "Imran Choudhary",
        "Position Name": "Associate Sales Manager (IHS Products & MRO Sales Engineer)",
        "Number of Positions": 2,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 - 20 Lac PA",
        "Billable CTC": 1500000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 46,
        "Position received date": "13-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "28-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position is tricky , they need candidate from DC and cooling  plates product line",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "09-Mar-25",
        "Client": "nVent",
        "HR name/HM": "Imran Choudhary",
        "Position Name": "Sales Manager - ICT/DC Solutions",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 - 20 Lac PA",
        "Billable CTC": 1500000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 47,
        "Position received date": "20-Dec-24",
        "Clarity call date": "20-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Jan-25",
        "Approx DOJ": "09-Jan-25",
        "Client": "CAMSonline",
        "HR name/HM": "Raj Kumar",
        "Position Name": "SDE 2 – Backend",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2200000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 166600,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagyashree",
        "Selected candidate name": "Ummadi Mani Kanta Reddy",
        "Recruiter name": "Sonal"
    },
    {
        "Sr.No": 48,
        "Position received date": "20-Dec-24",
        "Clarity call date": "20-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Jan-25",
        "Approx DOJ": "09-Jan-25",
        "Client": "CAMSonline",
        "HR name/HM": "Raj Kumar",
        "Position Name": "SDE 3 – Backend",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2800000,
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Bhagyashree"
    },
    {
        "Sr.No": 49,
        "Position received date": "11-Nov-24",
        "Clarity call date": "12-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "27-Nov-24",
        "Candidate Date of selection": "17-Jan-25",
        "Revised Target Date of Selection": "27-Nov-24",
        "Select to offer TAT": 3,
        "Approx Offer date": "30-Nov-24",
        "Actual Offer date": "23-Jan-25",
        "Official Notice Period": 90,
        "Approx DOJ": "28-Feb-25",
        "Actual DOJ candidate will join": "17th Mar'25",
        "Client": "John Deere",
        "HR name/HM": "Raju Palve/Paresh Baglane",
        "Position Name": "International Logistics Supervisor - G7",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1400648,
        "Billable CTC": 1321366,
        "Commercial %": 0.07,
        "Billing amount per position": 92495.62000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 92495.62000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Bhausaheb Sole",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 50,
        "Position received date": "22-Nov-24",
        "Clarity call date": "24-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "09-Dec-24",
        "Candidate Date of selection": "11-Feb-25",
        "Revised Target Date of Selection": "09-Dec-24",
        "Select to offer TAT": 3,
        "Approx Offer date": "12-Dec-24",
        "Actual Offer date": "13-Feb-25",
        "Official Notice Period": 30,
        "Approx DOJ": "11-Jan-25",
        "Actual DOJ candidate will join": "17th Mar'25",
        "Client": "John Deere",
        "HR name/HM": "Sagar Patil",
        "Position Name": "E - Commerce Content Developer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1400648,
        "Billable CTC": 1321366,
        "Commercial %": 0.07,
        "Billing amount per position": 92495.62000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 92495.62000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Linto Antony",
        "Recruiter name": "Varsha Nayak"
    },
    {
        "Sr.No": 51,
        "Position received date": "27-Nov-24",
        "Clarity call date": "02-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "17-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Budget constriant",
        "Select to offer TAT": 3,
        "Approx Offer date": "20-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "20-Mar-25",
        "Client": "John Deere",
        "HR name/HM": "Nitin Ambi",
        "Position Name": "Anaplan",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "22 LPA",
        "Billable CTC": 2000000,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 52,
        "Position received date": "19-Dec-24",
        "Clarity call date": "19-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "03-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Looking for internal candidates",
        "Select to offer TAT": 3,
        "Approx Offer date": "06-Jan-25",
        "Official Notice Period": 90,
        "Approx DOJ": "06-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Vaibhav Mahajan",
        "Position Name": "PIS",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1400648,
        "Billable CTC": 1321366,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 53,
        "Position received date": "30-Dec-24",
        "Clarity call date": "30-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-25",
        "Candidate Date of selection": "07-Jan-25",
        "Revised Target Date of Selection": "14-Jan-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "17-Jan-25",
        "Actual Offer date": "09-Jan-25",
        "Official Notice Period": 30,
        "Approx DOJ": "16-Feb-25",
        "Actual DOJ candidate will join": "20th Jan'25",
        "Client": "John Deere",
        "HR name/HM": "Priyanka Pawar",
        "Position Name": "TIS",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1400648,
        "Billable CTC": 1321366,
        "Commercial %": 0.07,
        "Billing amount per position": 92495.62000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 92495.62000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Vaibhav ",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 54,
        "Position received date": "30-Dec-24",
        "Clarity call date": "30-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-25",
        "Candidate Date of selection": "17-Jan-25",
        "Revised Target Date of Selection": "14-Jan-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "17-Jan-25",
        "Actual Offer date": "22-Jan-25",
        "Official Notice Period": 30,
        "Approx DOJ": "16-Feb-25",
        "Actual DOJ candidate will join": "24th Feb'25",
        "Client": "John Deere",
        "HR name/HM": "Khokan",
        "Position Name": "Training and Development",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1400648,
        "Billable CTC": 1321366,
        "Commercial %": 0.07,
        "Billing amount per position": 92495.62000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 92495.62000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Rupesh Shilpi",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 55,
        "Position received date": "09-Oct-24",
        "Clarity call date": "21-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "11-Dec-24",
        "Approx DOJ": "11-Dec-24",
        "Client": "TDK",
        "HR name/HM": "Ankita Khandelwal",
        "Position Name": "Sr Excutive / Manager - Automotive Sales",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1500000,
        "Billable CTC": 1300000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anand Raj"
    },
    {
        "Sr.No": 56,
        "Position received date": "09-Oct-24",
        "Clarity call date": "21-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "11-Dec-24",
        "Approx DOJ": "11-Dec-24",
        "Client": "TDK",
        "HR name/HM": "Ankita Khandelwal",
        "Position Name": "Key Accounts Manager  - Noida",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1500000,
        "Billable CTC": 1300000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anand Raj"
    },
    {
        "Sr.No": 57,
        "Position received date": "21-Nov-24",
        "Clarity call date": "29-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "19-Dec-24",
        "Approx DOJ": "19-Dec-24",
        "Client": "TDK",
        "HR name/HM": "Ankita Khandelwal",
        "Position Name": "Customer Service  - Mumbai",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anand Raj"
    },
    {
        "Sr.No": 58,
        "Position received date": "20-Nov-24",
        "Clarity call date": "09-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "24-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "29-Dec-24",
        "Approx DOJ": "29-Dec-24",
        "Client": "TCL",
        "HR name/HM": "Vindiya",
        "Position Name": "Marketing Manager  - Mumbai",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 1600000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Anand Raj"
    },
    {
        "Sr.No": 59,
        "Position received date": "20-Nov-24",
        "Clarity call date": "09-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "24-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "29-Dec-24",
        "Approx DOJ": "29-Dec-24",
        "Client": "TCL",
        "HR name/HM": "Vindiya",
        "Position Name": "Marketing Executive - Mumbai",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1500000,
        "Billable CTC": 1300000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Anand Raj"
    },
    {
        "Sr.No": 60,
        "Position received date": "20-Nov-24",
        "Clarity call date": "09-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "24-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "29-Dec-24",
        "Approx DOJ": "29-Dec-24",
        "Client": "TCL",
        "HR name/HM": "Vindiya",
        "Position Name": "Marketing Executive - Gujarat",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1200000,
        "Billable CTC": 1000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Anand Raj"
    },
    {
        "Sr.No": 61,
        "Position received date": "20-Nov-24",
        "Clarity call date": "09-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "24-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "29-Dec-24",
        "Approx DOJ": "29-Dec-24",
        "Client": "TCL",
        "HR name/HM": "Vindiya",
        "Position Name": "Marketing Executive - Chennai",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 900000,
        "Billable CTC": 800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Anand Raj"
    },
    {
        "Sr.No": 62,
        "Position received date": "20-Nov-24",
        "Clarity call date": "09-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "24-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "29-Dec-24",
        "Approx DOJ": "29-Dec-24",
        "Client": "TCL",
        "HR name/HM": "Vindiya",
        "Position Name": "Marketing Manager - Chennai",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1500000,
        "Billable CTC": 1300000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Anand Raj"
    },
    {
        "Sr.No": 63,
        "Position received date": "07-Nov-24",
        "Clarity call date": "15-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "30-Nov-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "07-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "07-Mar-25",
        "Client": "Agratas",
        "HR name/HM": "Saloni Singh",
        "Position Name": "Lead Architect - Integration",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 4200000,
        "Billable CTC": 3800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Anand Raj"
    },
    {
        "Sr.No": 64,
        "Position received date": "20-11-2024",
        "Clarity call date": "12-May-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "27-May-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "01-Jun-24",
        "Approx DOJ": "01-Jun-24",
        "Client": "Ultramarine Pigment",
        "HR name/HM": "Midula",
        "Position Name": "Manager/Deputy Manager –Industrial Sales (Domestic) ",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1600000,
        "Billable CTC": 1200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Anand Raj"
    },
    {
        "Sr.No": 65,
        "Position received date": "25-Sep-24",
        "Clarity call date": "25-Sep-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Oct-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Someone identified from other sources",
        "Select to offer TAT": 5,
        "Approx Offer date": "15-Oct-24",
        "Official Notice Period": 90,
        "Approx DOJ": "13-Jan-25",
        "Client": "Endurance",
        "HR name/HM": "Nidhi Naik",
        "Position Name": "Section Head - RLDA",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "21 LPA",
        "Billable CTC": 1850000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 66,
        "Position received date": "18-Oct-24",
        "Clarity call date": "18-Oct-24",
        "Position renew date": "10-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Jan-25",
        "Candidate Date of selection": "30-Jan-25",
        "Revised Target Date of Selection": "25-Jan-25",
        "Reason of delay/HOLD": "Position is niche and they were looking for a female candidate  in SAP FICO with Eurpean Accounting standard and ctc budget iwas also low  hence it took time",
        "Select to offer TAT": 5,
        "Approx Offer date": "30-Jan-25",
        "Actual Offer date": "10-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "30-Apr-25",
        "Actual DOJ candidate will join": "03-Mar-25",
        "Client": "Endurance",
        "HR name/HM": "Nidhi Naik",
        "Position Name": "SAP FICO Consultant",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1150010,
        "Billable CTC": 1150010,
        "Commercial %": 0.0833,
        "Billing amount per position": 95795.833,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 95795.833,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Selected candidate name": "Pooja Thorat",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 67,
        "Position received date": "18-Nov-24",
        "Clarity call date": "18-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "03-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Closed internally",
        "Select to offer TAT": 5,
        "Approx Offer date": "08-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "08-Mar-25",
        "Client": "Endurance",
        "HR name/HM": "Shital Janjal",
        "Position Name": "Zonal Manager",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "30 LPA",
        "Billable CTC": 2800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 68,
        "Position received date": "18-Nov-24",
        "Clarity call date": "18-Nov-24",
        "Position renew date": "10-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback delay and Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "01-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "02-May-25",
        "Client": "Endurance",
        "HR name/HM": "Shital Janjal",
        "Position Name": "Regional Manager - Maharasthra",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "21 LPA",
        "Billable CTC": 1850000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 69,
        "Position received date": "22-Nov-24",
        "Clarity call date": "22-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Not getting feedback since 20 days and hence its kept on hold for now",
        "Select to offer TAT": 5,
        "Approx Offer date": "12-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "12-Mar-25",
        "Client": "Endurance",
        "HR name/HM": "Harsha Vardhan",
        "Position Name": "Vendor Development Engineer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "30 LPA",
        "Billable CTC": 2800000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 70,
        "Position received date": "17-Dec-24",
        "Clarity call date": "17-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Jan-25",
        "Candidate Date of selection": "12-Dec-24",
        "Revised Target Date of Selection": "01-Jan-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "04-Jan-25",
        "Actual Offer date": "13-Dec-24",
        "Official Notice Period": 60,
        "Approx DOJ": "05-Mar-25",
        "Actual DOJ candidate will join": "17-Feb-25",
        "Client": "John Deere",
        "HR name/HM": "HM Veeresh",
        "Position Name": "ME Assembly (Data Analyst) - G6",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "17 LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.07,
        "Billing amount per position": 105000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 105000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Hema",
        "Selected candidate name": "Omkar Autade",
        "Recruiter name": "Hema Chaudhary"
    },
    {
        "Sr.No": 71,
        "Position received date": "18-Dec-24",
        "Clarity call date": "18-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Jan-25",
        "Candidate Date of selection": "29-Jan-25",
        "Revised Target Date of Selection": "02-Jan-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "05-Jan-25",
        "Actual Offer date": "31-Jan-25",
        "Official Notice Period": 90,
        "Approx DOJ": "05-Apr-25",
        "Actual DOJ candidate will join": "15th May'25",
        "Client": "John Deere",
        "HR name/HM": "Pritam Marawar",
        "Position Name": "Electrical Lead Engineer - G7",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2800000,
        "Billable CTC": 2500000,
        "Commercial %": 0.07,
        "Billing amount per position": 175000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 175000.00000000003,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Mohan Krishna Ejjagiri",
        "Recruiter name": "Simran Gupta"
    },
    {
        "Sr.No": 72,
        "Position received date": "03-Jan-25",
        "Clarity call date": "03-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "18-Jan-25",
        "Candidate Date of selection": "27-Jan-25",
        "Revised Target Date of Selection": "18-Jan-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "21-Jan-25",
        "Actual Offer date": "30-Jan-25",
        "Official Notice Period": 30,
        "Approx DOJ": "20-Feb-25",
        "Actual DOJ candidate will join": "24th Feb'25",
        "Client": "John Deere",
        "HR name/HM": "Rajeev Kumar",
        "Position Name": "Lead - Strategic Supplier Quality Engineer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2800000,
        "Billable CTC": 2500000,
        "Commercial %": 0.07,
        "Billing amount per position": 175000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 175000.00000000003,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Dhiraj Pandey",
        "Recruiter name": "Simran Gupta"
    },
    {
        "Sr.No": 73,
        "Position received date": "12-Dec-24",
        "Clarity call date": "13-Dec-24",
        "Position renew date": "10-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Delay in the feedback and Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "01-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "02-Apr-25",
        "Client": "Endurance",
        "HR name/HM": "Nidhi Naik",
        "Position Name": "CAE Lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "21 LPA",
        "Billable CTC": 1980000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 74,
        "Position received date": "12-Dec-24",
        "Clarity call date": "13-Dec-24",
        "Position renew date": "10-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Delay in the feedback and Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "01-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "02-May-25",
        "Client": "Endurance",
        "HR name/HM": "Nidhi Naik",
        "Position Name": "CAE Analyst",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 LPA",
        "Billable CTC": 1350000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 75,
        "Position received date": "15-Jan-25",
        "Clarity call date": "15-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "30-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "They want to close junior role first, hence HM has ket this position on hold",
        "Select to offer TAT": 5,
        "Approx Offer date": "04-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "05-May-25",
        "Client": "Endurance",
        "HR name/HM": "Nitin Kakde",
        "Position Name": "Crop EHS&S Management System Leader",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "30 LPA",
        "Billable CTC": 2800000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 76,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "15-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "30-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Not getting candidates Export sales candidates from latin America and who can speak Spanish",
        "Select to offer TAT": 7,
        "Approx Offer date": "06-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "07-May-25",
        "Client": "Endurance",
        "HR name/HM": "Shital Janjal",
        "Position Name": "Regional Head- LATAM",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "25 LPA",
        "Billable CTC": 2200000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 77,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "15-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "30-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Not getting candidates Export sales candidates who are looking south Africa",
        "Select to offer TAT": 7,
        "Approx Offer date": "06-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "07-May-25",
        "Client": "Endurance",
        "HR name/HM": "Shital Janjal",
        "Position Name": "Regional Head- Africa",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "25 LPA",
        "Billable CTC": 2200000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 78,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Panel is not giving feedback of the old shared profiles hence Hr said to hold",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "09-Mar-25",
        "Client": "Endurance",
        "HR name/HM": "Durga Rathod",
        "Position Name": "AGM (MIS)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "37 LPA",
        "Billable CTC": 3500000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 79,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Dec-24",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Panel is not giving feedback of the old shared profiles hence Hr said to hold",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "09-Mar-25",
        "Client": "Endurance",
        "HR name/HM": "Durga Rathod",
        "Position Name": "Sr. Manager (Costing)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "28 LPA",
        "Billable CTC": 2600000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 80,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "10-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "01-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "02-Apr-25",
        "Client": "Endurance",
        "HR name/HM": "Nidhi Naik",
        "Position Name": "MFA Lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18 LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 81,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "05-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "27-Mar-25",
        "Official Notice Period": 90,
        "Approx DOJ": "25-Jun-25",
        "Client": "Endurance",
        "HR name/HM": "Nidhi Naik",
        "Position Name": "HPDC Junior",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "20 LPA",
        "Billable CTC": 1800000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 82,
        "Position received date": "16-Jan-25",
        "Clarity call date": "16-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "31-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Duplicity",
        "Select to offer TAT": 5,
        "Approx Offer date": "05-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "06-Apr-25",
        "Client": "HP",
        "HR name/HM": "Mayur Satardekar",
        "Position Name": "Production Manager - Operation-Refinery",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "35 LPA",
        "Billable CTC": 3200000,
        "Commercial %": 0.125,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 83,
        "Position received date": "23-Jan-25",
        "Clarity call date": "24-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-Feb-25",
        "Candidate Date of selection": "14-Feb-25",
        "Revised Target Date of Selection": "08-Feb-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "11-Feb-25",
        "Actual Offer date": "18-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "12-Apr-25",
        "Actual DOJ candidate will join": "23rd Apr'25",
        "Client": "John Deere",
        "HR name/HM": "Kishor Chandoba",
        "Position Name": "Quality",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1400648,
        "Billable CTC": 1321366,
        "Commercial %": 0.08,
        "Billing amount per position": 105709.28,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 105709.28,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Mitali Madhukar Tekade",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 84,
        "Position received date": "20-Jan-25",
        "Clarity call date": "20-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback delay and Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "11-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "12-Apr-25",
        "Client": "Endurance",
        "HR name/HM": "Shital Janjal",
        "Position Name": "Regional Manager-North",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18 LPA",
        "Billable CTC": 155000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 85,
        "Position received date": "20-Jan-25",
        "Clarity call date": "20-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback delay and Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "11-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "12-Apr-25",
        "Client": "Endurance",
        "HR name/HM": "Shital Janjal",
        "Position Name": "Regional Manager-West",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18 LPA",
        "Billable CTC": 155000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 86,
        "Position received date": "20-Jan-25",
        "Clarity call date": "20-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback delay and Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "11-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "12-Apr-25",
        "Client": "Endurance",
        "HR name/HM": "Shital Janjal",
        "Position Name": "Regional Manager-East",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18 LPA",
        "Billable CTC": 155000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 87,
        "Position received date": "23-Jan-25",
        "Clarity call date": "23-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "14-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "15-May-25",
        "Client": "Endurance",
        "HR name/HM": "Shital Janjal",
        "Position Name": "Quality Head-B20",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "20 LPA",
        "Billable CTC": 1750000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 88,
        "Position received date": "23-Jan-25",
        "Clarity call date": "23-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "14-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "15-May-25",
        "Client": "Endurance",
        "HR name/HM": "Shital Janjal",
        "Position Name": "Quality Head - B22",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "20 LPA",
        "Billable CTC": 1750000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 89,
        "Position received date": "16-Jan-25",
        "Clarity call date": "23-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback delayed, They need candidate who is having international exposure for atleast 2 years and budget is less",
        "Select to offer TAT": 5,
        "Approx Offer date": "12-Feb-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Mar-25",
        "Client": "Praj",
        "HR name/HM": "Kajari Mahapatra",
        "Position Name": "Safety officer - Checmical - 1st priority",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "10 - 17 LPA ",
        "Billable CTC": 1500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 90,
        "Position received date": "23-Jan-25",
        "Clarity call date": "23-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback delayed, They need candidate who is having international exposure for atleast 2 years and budget is less",
        "Select to offer TAT": 5,
        "Approx Offer date": "12-Feb-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Mar-25",
        "Client": "Praj",
        "HR name/HM": "Kajari Mahapatra",
        "Position Name": "Contract Manager (FIDIC)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "25 LPA",
        "Billable CTC": 2200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 91,
        "Position received date": "16-Jan-25",
        "Clarity call date": "23-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback delayed, They need candidate who is having international exposure for atleast 2 years and budget is less",
        "Select to offer TAT": 5,
        "Approx Offer date": "12-Feb-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Mar-25",
        "Client": "Praj",
        "HR name/HM": "Kajari Mahapatra",
        "Position Name": "Site Planner - Chemical",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "10 - 15 LPA ",
        "Billable CTC": 1200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 92,
        "Position received date": "16-Jan-25",
        "Clarity call date": "23-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback delayed, They need candidate who is having international exposure for atleast 2 years and budget is less",
        "Select to offer TAT": 5,
        "Approx Offer date": "12-Feb-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Mar-25",
        "Client": "Praj",
        "HR name/HM": "Kajari Mahapatra",
        "Position Name": "Site Quality Engineer - Lead Mechanical",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15- 22 LPA ",
        "Billable CTC": 1800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 93,
        "Position received date": "16-Jan-25",
        "Clarity call date": "23-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback delayed, They need candidate who is having international exposure for atleast 2 years and budget is less",
        "Select to offer TAT": 5,
        "Approx Offer date": "12-Feb-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Mar-25",
        "Client": "Praj",
        "HR name/HM": "Kajari Mahapatra",
        "Position Name": "Site Quality Engineer - Civil",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "12 - 20 LPA ",
        "Billable CTC": 1600000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 94,
        "Position received date": "16-Jan-25",
        "Clarity call date": "23-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback delayed, They need candidate who is having international exposure for atleast 2 years and budget is less",
        "Select to offer TAT": 5,
        "Approx Offer date": "12-Feb-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Mar-25",
        "Client": "Praj",
        "HR name/HM": "Kajari Mahapatra",
        "Position Name": "Site Quality Engineer - Mechanical",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "10 - 15 LPA ",
        "Billable CTC": 1200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 95,
        "Position received date": "23-Jan-25",
        "Clarity call date": "23-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback delayed, They need candidate who is having international exposure for atleast 2 years and budget is less",
        "Select to offer TAT": 5,
        "Approx Offer date": "12-Feb-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Mar-25",
        "Client": "Praj",
        "HR name/HM": "Kajari Mahapatra",
        "Position Name": "RCM",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "30 LPA",
        "Billable CTC": 2800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 96,
        "Position received date": "03-Feb-25",
        "Clarity call date": "03-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "18-Feb-25",
        "Candidate Date of selection": "28-May-25",
        "Revised Target Date of Selection": "18-Feb-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "21-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "22-May-25",
        "Client": "John Deere",
        "HR name/HM": "Vishal Rane",
        "Position Name": "(111405) Lead Engineer - CVML G7)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2450000,
        "Billable CTC": 2000000,
        "Commercial %": 0.07,
        "Billing amount per position": 140000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 140000,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Swaraj mohan",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 97,
        "Position received date": "04-Feb-25",
        "Clarity call date": "26-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "16-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "15-May-25",
        "Client": "John Deere",
        "HR name/HM": "Amarnath Gupta",
        "Position Name": "Matlab, Simulink and Stateflow - G6",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "24 LPA",
        "Billable CTC": 2200000,
        "Commercial %": 0.07,
        "Billing amount per position": 154000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 154000.00000000003,
        "Status": "Active",
        "Current delivery update": "1 l1 fb pending, 6 L1 slots pending, 5 cvs shared on 21Mar'25",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Gupta"
    },
    {
        "Sr.No": 98,
        "Position received date": "06-Feb-25",
        "Clarity call date": "26-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "16-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "15-May-25",
        "Client": "John Deere",
        "HR name/HM": "Amarnath Gupta",
        "Position Name": "Matlab, Simulink and Stateflow - G6",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "24 LPA",
        "Billable CTC": 2200000,
        "Commercial %": 0.07,
        "Billing amount per position": 154000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 154000.00000000003,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Gupta"
    },
    {
        "Sr.No": 99,
        "Position received date": "04-Feb-25",
        "Clarity call date": "26-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "16-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "15-May-25",
        "Client": "John Deere",
        "HR name/HM": "Akshay Misal",
        "Position Name": "Matlab, Simulink and Stateflow - G6",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "24 LPA",
        "Billable CTC": 2200000,
        "Commercial %": 0.07,
        "Billing amount per position": 154000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 154000.00000000003,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Gupta"
    },
    {
        "Sr.No": 100,
        "Position received date": "25-Nov-24",
        "Clarity call date": "20-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Feb-25",
        "Candidate Date of selection": "13-Feb-25",
        "Revised Target Date of Selection": "04-Feb-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "07-Feb-25",
        "Actual Offer date": "25-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "08-Apr-25",
        "Actual DOJ candidate will join": "28-Apr'25",
        "Client": "John Deere",
        "HR name/HM": "Aditya Garg / Ishani Pandit",
        "Position Name": "Supervisor G8",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "42LPA",
        "Billable CTC": 3500000,
        "Commercial %": 0.07,
        "Billing amount per position": 245000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 245000.00000000003,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Gupta",
        "Selected candidate name": "Sumit kumar"
    },
    {
        "Sr.No": 101,
        "Position received date": "19-Nov-24",
        "Clarity call date": "19-Nov-24",
        "Position renew date": "29-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-Feb-25",
        "Candidate Date of selection": "17-Feb-25",
        "Revised Target Date of Selection": "13-Feb-25",
        "Reason of delay/HOLD": "Seema candidate Backout on 29th Jan & Delay in the feedback ",
        "Select to offer TAT": 7,
        "Approx Offer date": "20-Feb-25",
        "Actual Offer date": "20-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "21-May-25",
        "Actual DOJ candidate will join": "2nd Jun'25",
        "Client": "Endurance",
        "HR name/HM": "Nidhi Naik",
        "Position Name": "PLM Incharge",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "12.5 LPA",
        "Billable CTC": 1050000,
        "Commercial %": 0.0833,
        "Billing amount per position": 87465,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 87465,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Selected candidate name": "Kishor Mutake",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 102,
        "Position received date": "30-Jan-25",
        "Clarity call date": "30-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Mar-25",
        "Candidate Date of selection": "18-Feb-25",
        "Revised Target Date of Selection": "07-Mar-25",
        "Reason of delay/HOLD": "Delay in feedback and Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "14-Mar-25",
        "Actual Offer date": "20-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "12-Jun-25",
        "Actual DOJ candidate will join": "07-Apr-25",
        "Client": "Endurance",
        "HR name/HM": "Durga Rathod",
        "Position Name": "Executive Accounts",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "5.9 LPA",
        "Billable CTC": 590000,
        "Commercial %": 0.0833,
        "Billing amount per position": 49147,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 49147,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Selected candidate name": "Dhaval Tejabhai Prajapati ",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 103,
        "Position received date": "30-Jan-25",
        "Clarity call date": "30-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback Delay",
        "Select to offer TAT": 7,
        "Approx Offer date": "21-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "22-Apr-25",
        "Client": "Endurance",
        "HR name/HM": "Shalini Raj",
        "Position Name": "Sr.Officer Accounts",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "7 LPA",
        "Billable CTC": 620000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 104,
        "Position received date": "28-Jan-25",
        "Clarity call date": "28-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position is tricky , they need candidate from DC and cooling  plates product line",
        "Select to offer TAT": 5,
        "Approx Offer date": "17-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "18-May-25",
        "Client": "Nvent",
        "HR name/HM": "Shifa",
        "Position Name": "FAE",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "24 LPA",
        "Billable CTC": 2000000,
        "Commercial %": 0.15,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 105,
        "Position received date": "29-Jan-25",
        "Clarity call date": "29-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-Feb-25",
        "Candidate Date of selection": "19-Feb-25",
        "Revised Target Date of Selection": "13-Feb-25",
        "Reason of delay/HOLD": "Requirement of the profile is little tricky, they need candidate at senior level doing 80% IC role",
        "Select to offer TAT": 7,
        "Approx Offer date": "20-Feb-25",
        "Actual Offer date": "29-Jan-25",
        "Official Notice Period": 90,
        "Approx DOJ": "21-May-25",
        "Actual DOJ candidate will join": "19-May-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna",
        "Position Name": "GM IT Infra",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "60 LPA",
        "Billable CTC": 5100000,
        "Commercial %": 0.12,
        "Billing amount per position": 612000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 612000,
        "Status": "Closed",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Selected candidate name": "Final select - Nilanjan -  Backup - Navjot Singh Pabla",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 106,
        "Position received date": "31-Jan-25",
        "Clarity call date": "31-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "15-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Delay in the feedback",
        "Select to offer TAT": 7,
        "Approx Offer date": "22-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "23-May-25",
        "Client": "Endurance",
        "HR name/HM": "Nitin Kakde",
        "Position Name": "ESG",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "13 LPA",
        "Billable CTC": 1220000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 107,
        "Position received date": "03-Feb-25",
        "Clarity call date": "03-Feb-25",
        "Position renew date": "12-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "27-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Panel will change the skill set againt",
        "Select to offer TAT": 7,
        "Approx Offer date": "03-Apr-25",
        "Official Notice Period": 90,
        "Approx DOJ": "02-Jul-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "DGM IT Infra",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "35 LPA",
        "Billable CTC": 3000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 108,
        "Position received date": "21-Oct-24",
        "Clarity call date": "21-Oct-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-00",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Looking for vendor's end profiles",
        "Select to offer TAT": 3,
        "Approx Offer date": "17-Jan-00",
        "Official Notice Period": 90,
        "Approx DOJ": "17-Apr-00",
        "Client": "John Deere",
        "HR name/HM": "Rakesh Nehete",
        "Position Name": "Quality engineer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1400648,
        "Billable CTC": 1321366,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 109,
        "Position received date": "03-Feb-25",
        "Clarity call date": "03-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "18-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "23-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "24-May-25",
        "Client": "LNT  PT&D",
        "HR name/HM": "Danya Dasan",
        "Position Name": "PMO",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 4000000,
        "Billable CTC": 2500000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 110,
        "Position received date": "03-Feb-25",
        "Clarity call date": "03-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "18-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "23-Feb-25",
        "Official Notice Period": 15,
        "Approx DOJ": "10-Mar-25",
        "Client": "LNT  PT&D",
        "HR name/HM": "Danya Dasan",
        "Position Name": "PMO",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 4000000,
        "Billable CTC": 2500000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 111,
        "Position received date": "07-Jan-25",
        "Clarity call date": "07-Jan-25",
        "Position renew date": "04-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "15-Mar-25",
        "Candidate Date of selection": "08-Apr-25",
        "Revised Target Date of Selection": "15-Mar-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "18-Mar-25",
        "Actual Offer date": "14-Jan-25",
        "Official Notice Period": 90,
        "Approx DOJ": "16-Jun-25",
        "Actual DOJ candidate will join": "16th Jun'25",
        "Client": "John Deere",
        "HR name/HM": "Kiran Bachhav",
        "Position Name": "Embedded Software",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 3000000,
        "Billable CTC": 2200000,
        "Commercial %": 0.07,
        "Billing amount per position": 154000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 154000.00000000003,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Amar Shinde",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 112,
        "Position received date": "04-Feb-25",
        "Clarity call date": "04-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "25-Feb-25",
        "Actual Offer date": "05-Feb-25",
        "Approx DOJ": "25-Feb-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Priya Shool",
        "Position Name": "SCOPE and Model Care Coordinator - onsite",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18LPA",
        "Billable CTC": 1600000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 113,
        "Position received date": "04-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "25-Feb-25",
        "Actual Offer date": "05-Feb-25",
        "Approx DOJ": "25-Feb-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Priya Shool",
        "Position Name": "CAE - Durablity Simulation Engineer - ICE - Onsite",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "20LPA",
        "Billable CTC": 1800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 114,
        "Position received date": "04-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "25-Feb-25",
        "Actual Offer date": "05-Feb-25",
        "Approx DOJ": "25-Feb-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Priya Shool",
        "Position Name": "New Projects Co-Ordinator",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15LPA",
        "Billable CTC": 1300000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 115,
        "Position received date": "04-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "25-Feb-25",
        "Actual Offer date": "05-Feb-25",
        "Approx DOJ": "25-Feb-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Sneha Kota",
        "Position Name": "Integration Engineer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15LPA",
        "Billable CTC": 1300000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 116,
        "Position received date": "04-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "25-Feb-25",
        "Actual Offer date": "05-Feb-25",
        "Approx DOJ": "25-Feb-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Priya Shool",
        "Position Name": "CAE - Durablility Model Build Engineer – BEV",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "20LPA",
        "Billable CTC": 1800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 117,
        "Position received date": "04-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "25-Feb-25",
        "Actual Offer date": "05-Feb-25",
        "Approx DOJ": "25-Feb-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Priya Shool",
        "Position Name": "CAE - Slow speed Simulation Engineer – BEV",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "20LPA",
        "Billable CTC": 1800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 118,
        "Position received date": "04-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "25-Feb-25",
        "Actual Offer date": "05-Feb-25",
        "Approx DOJ": "25-Feb-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Sneha Kota",
        "Position Name": "Function Owner – CSMS and security Concept",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15LPA",
        "Billable CTC": 1300000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 119,
        "Position received date": "04-Feb-25",
        "Clarity call date": "04-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-00",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "19-Jan-00",
        "Official Notice Period": 90,
        "Approx DOJ": "19-Apr-00",
        "Client": "ApplusIDadia",
        "HR name/HM": "Sneha Kota",
        "Position Name": "Team leader/ Senior Team Leader- Vehicle Dynamics",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "25LPA",
        "Billable CTC": 2200000,
        "Commercial %": 0.105,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Afzal ahmed",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 120,
        "Position received date": "11-Feb-25",
        "Clarity call date": "11-Feb-25",
        "Position renew date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Got new update from the Panel 17th Mar and feedback delay",
        "Select to offer TAT": 5,
        "Approx Offer date": "06-Apr-25",
        "Official Notice Period": 90,
        "Approx DOJ": "05-Jul-25",
        "Client": "TDK",
        "HR name/HM": "Yogesh Nisal",
        "Position Name": "Sr.Software Enginer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 LPA",
        "Billable CTC": 1250000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 121,
        "Position received date": "24-Dec-24",
        "Clarity call date": "24-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-Jan-25",
        "Candidate Date of selection": "27-Jan-25",
        "Revised Target Date of Selection": "08-Jan-25",
        "Reason of delay/HOLD": "Lack of Req id and over hiring",
        "Select to offer TAT": 3,
        "Approx Offer date": "11-Jan-25",
        "Actual Offer date": "24-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "11-Apr-25",
        "Actual DOJ candidate will join": "26-May-25",
        "Client": "John Deere",
        "HR name/HM": "Chetana Wasnik",
        "Position Name": "EMB C/ MATLAB developer - G6",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1500000,
        "Commercial %": 0.07,
        "Billing amount per position": 105000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 105000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Newton Nadar",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 122,
        "Position received date": "11-Feb-25",
        "Clarity call date": "11-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "26-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Internal duplicacy issue / Not sharing the list",
        "Select to offer TAT": 5,
        "Approx Offer date": "03-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "02-May-25",
        "Client": "TDK",
        "HR name/HM": "Ankita Khandelwal",
        "Position Name": "KEM-Noida",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 LPA",
        "Billable CTC": 1250000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 123,
        "Position received date": "10-Feb-25",
        "Clarity call date": "10-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Internal duplicacy issue / Not sharing the list",
        "Select to offer TAT": 5,
        "Approx Offer date": "02-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "01-May-25",
        "Client": "TDK",
        "HR name/HM": "Ankita Khandelwal",
        "Position Name": "KEM-Noida",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "22 LPA",
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 124,
        "Position received date": "10-Feb-25",
        "Clarity call date": "10-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Internal duplicacy issue / Not sharing the list",
        "Select to offer TAT": 5,
        "Approx Offer date": "02-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "01-May-25",
        "Client": "TDK",
        "HR name/HM": "Ankita Khandelwal",
        "Position Name": "Business Development",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "25 LPA",
        "Billable CTC": 2350000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 125,
        "Position received date": "10-Feb-25",
        "Clarity call date": "10-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Internal duplicacy issue / Not sharing the list",
        "Select to offer TAT": 5,
        "Approx Offer date": "02-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "01-May-25",
        "Client": "TDK",
        "HR name/HM": "Ankita Khandelwal",
        "Position Name": "KEM-Bangalore",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "16 LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 126,
        "Position received date": "07-Feb-25",
        "Clarity call date": "07-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-00",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "17-Jan-00",
        "Official Notice Period": 60,
        "Approx DOJ": "18-Mar-00",
        "Client": "John Deere",
        "HR name/HM": "Chuntan Patel/Santosh Shelke",
        "Position Name": "ME Assembly",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 150000,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 127,
        "Position received date": "10-Nov-24",
        "Clarity call date": "10-Nov-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Nov-24",
        "Candidate Date of selection": "04-Jan-25",
        "Revised Target Date of Selection": "25-Nov-24",
        "Select to offer TAT": 3,
        "Approx Offer date": "28-Nov-24",
        "Actual Offer date": "13-Nov-24",
        "Official Notice Period": 90,
        "Approx DOJ": "26-Feb-25",
        "Actual DOJ candidate will join": "17-Mar-25",
        "Client": "John Deere",
        "HR name/HM": "Prashanth Pandey",
        "Position Name": "Display developement G6 (108576)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1500000,
        "Commercial %": 0.07,
        "Billing amount per position": 105000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 105000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Gotyala Naveen kumar",
        "Recruiter name": " Priyanka"
    },
    {
        "Sr.No": 128,
        "Position received date": "18-Dec-24",
        "Clarity call date": "20-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Jan-25",
        "Candidate Date of selection": "18-Apr-25",
        "Revised Target Date of Selection": "04-Jan-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "07-Jan-25",
        "Actual Offer date": "21-Apr-25",
        "Official Notice Period": 90,
        "Approx DOJ": "07-Apr-25",
        "Actual DOJ candidate will join": "26th may 25",
        "Client": "John Deere",
        "HR name/HM": "Vishal Rane",
        "Position Name": "(109816) Sr Engineer (EMB C++ - G6)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1500000,
        "Commercial %": 0.07,
        "Billing amount per position": 105000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 105000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Bhibhas morang",
        "Recruiter name": "priyanka"
    },
    {
        "Sr.No": 129,
        "Position received date": "17-Feb-25",
        "Clarity call date": "17-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "11-Mar-25",
        "Actual Offer date": "19-Feb-25",
        "Approx DOJ": "11-Mar-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Sneha Kota",
        "Position Name": "VTT Coordinator(off role)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "4.5 to 8 L",
        "Billable CTC": 600000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 130,
        "Position received date": "17-Feb-25",
        "Clarity call date": "17-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "11-Mar-25",
        "Actual Offer date": "19-Feb-25",
        "Approx DOJ": "11-Mar-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Sneha Kota",
        "Position Name": "Workshop Senior Technician",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "8 to 9 L",
        "Billable CTC": 700000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 131,
        "Position received date": "17-Feb-25",
        "Clarity call date": "17-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "11-Mar-25",
        "Actual Offer date": "19-Feb-25",
        "Approx DOJ": "11-Mar-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Sneha Kota",
        "Position Name": "Specialist Emission test measurement RDE",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "7 to 10L",
        "Billable CTC": 800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 132,
        "Position received date": "17-Feb-25",
        "Clarity call date": "17-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "11-Mar-25",
        "Actual Offer date": "19-Feb-25",
        "Approx DOJ": "11-Mar-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Sneha Kota",
        "Position Name": "Testing Eng. – Door & tailgate",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 to 20 L",
        "Billable CTC": 1700000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 133,
        "Position received date": "19-Feb-25",
        "Clarity call date": "19-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Mar-25",
        "Candidate Date of selection": "08-Apr-25",
        "Revised Target Date of Selection": "06-Mar-25",
        "Reason of delay/HOLD": "SOP alogorithm development candidates are less in the market, position is niche hence not able to find the relevant pool 7 Duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "13-Mar-25",
        "Actual Offer date": "29-Apr-25",
        "Official Notice Period": 90,
        "Approx DOJ": "11-Jun-25",
        "Actual DOJ candidate will join": "07-Jul-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "BMS Engineer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "65LPA",
        "Billable CTC": 5525000,
        "Commercial %": 0.0833,
        "Billing amount per position": 460232.5,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 460232.5,
        "Status": "Closed",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Selected candidate name": "Manohar Gottapu",
        "Recruiter name": "Anupama"
    },
    {
        "Sr.No": 134,
        "Position received date": "15-Nov-24",
        "Clarity call date": "20-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Feb-25",
        "Candidate Date of selection": "17-Feb-25",
        "Revised Target Date of Selection": "04-Feb-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "07-Feb-25",
        "Actual Offer date": "20-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "08-Apr-25",
        "Actual DOJ candidate will join": "28-Apr'25",
        "Client": "John Deere",
        "HR name/HM": "Prashanth Pandey",
        "Position Name": "Display developement G6 ",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "18 LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.08,
        "Billing amount per position": 120000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 120000,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Gupta",
        "Selected candidate name": "Poonam Sangale",
        "Recruiter name": "Amita"
    },
    {
        "Sr.No": 135,
        "Position received date": "31-Jan-25",
        "Clarity call date": "03-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "18-Feb-25",
        "Candidate Date of selection": "20-Feb-25",
        "Revised Target Date of Selection": "18-Feb-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "21-Feb-25",
        "Actual Offer date": "26-Feb-25",
        "Official Notice Period": 90,
        "Approx DOJ": "22-May-25",
        "Actual DOJ candidate will join": "23rd May'25",
        "Client": "John Deere",
        "HR name/HM": "Anjali Kumari",
        "Position Name": "Problem Resolution Specialist - G6",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2100000,
        "Billable CTC": 1600000,
        "Commercial %": 0.07,
        "Billing amount per position": 112000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 112000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Amrita Rai",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 136,
        "Position received date": "24-Feb-25",
        "Clarity call date": "25-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "15-Mar-25",
        "Official Notice Period": 90,
        "Approx DOJ": "13-Jun-25",
        "Client": "John Deere",
        "HR name/HM": "Vishal Rane",
        "Position Name": "Lead Engineer - (111105) - Data Engineer",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "25LPA",
        "Billable CTC": 2200000,
        "Commercial %": 0.07,
        "Billing amount per position": 154000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 154000.00000000003,
        "Status": "Active",
        "Current delivery update": "3L3 in line",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 137,
        "Position received date": "24-Feb-25",
        "Clarity call date": "26-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "11-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "14-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "13-May-25",
        "Client": "John Deere",
        "HR name/HM": "Vishal Rane - Nikhil Temkar",
        "Position Name": "Lead Engineer Embedded C++(111406)  - G7",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "35LPA",
        "Billable CTC": 3200000,
        "Commercial %": 0.07,
        "Billing amount per position": 224000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 224000.00000000003,
        "Status": "Active",
        "Current delivery update": "2 l1 fb pending",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Gupta"
    },
    {
        "Sr.No": 138,
        "Position received date": "24-Feb-25",
        "Clarity call date": "26-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "11-Mar-25",
        "Candidate Date of selection": "21-Mar-25",
        "Revised Target Date of Selection": "11-Mar-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "14-Mar-25",
        "Actual Offer date": "27-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "13-May-25",
        "Actual DOJ candidate will join": "26-May-25",
        "Client": "John Deere",
        "HR name/HM": "Vishal Rane -Raj Bhanushali",
        "Position Name": "Lead engineer Embedded C(111405) - G7",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "35LPA",
        "Billable CTC": 3200000,
        "Commercial %": 0.07,
        "Billing amount per position": 224000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 224000.00000000003,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Gupta",
        "Selected candidate name": "Nishit Pattanayak",
        "Recruiter name": "Kausar Jahan"
    },
    {
        "Sr.No": 139,
        "Position received date": "27-Feb-25",
        "Clarity call date": "27-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Duplicity & Delay in feedback",
        "Select to offer TAT": 7,
        "Approx Offer date": "21-Mar-25",
        "Official Notice Period": 90,
        "Approx DOJ": "19-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "DGM IT Procurement",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "45 LPA",
        "Billable CTC": 4000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 140,
        "Position received date": "27-Feb-25",
        "Clarity call date": "03-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Mar-25",
        "Candidate Date of selection": "21-Mar-25",
        "Revised Target Date of Selection": "14-Mar-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "17-Mar-25",
        "Actual Offer date": "27-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "16-May-25",
        "Actual DOJ candidate will join": "28-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Ishani pandit ",
        "Position Name": "Data Analysis - G6",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "24 LPA",
        "Billable CTC": 2200000,
        "Commercial %": 0.07,
        "Billing amount per position": 154000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 154000.00000000003,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Gupta",
        "Selected candidate name": "Kamini Bhor",
        "Recruiter name": "Bhawna Miglani"
    },
    {
        "Sr.No": 141,
        "Position received date": "28-Jan-25",
        "Clarity call date": "28-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Feb-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "15-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "16-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Rucha deshmukh",
        "Position Name": "Sr engineer Matlab engine Test and Validation - G6",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "18LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.07,
        "Billing amount per position": 105000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 105000.00000000001,
        "Status": "Active",
        "Current delivery update": "1 L1 fb pending & 1 L1 inline for 24th Mar'25, 4 cv fb pending",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Gupta"
    },
    {
        "Sr.No": 142,
        "Position received date": "17-Feb-25",
        "Clarity call date": "18-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "07-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "06-Apr-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Amal Ashok",
        "Position Name": "Embedded C & RTOS - internal",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "(15-26/28) LPA",
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Shruti Gupta",
        "Recruiter name": "Bhawna/Mahima"
    },
    {
        "Sr.No": 143,
        "Position received date": "17-Feb-25",
        "Clarity call date": "18-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Mar-25",
        "Candidate Date of selection": "18-Mar-25",
        "Revised Target Date of Selection": "04-Mar-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "07-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "06-Apr-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Amal Ashok",
        "Position Name": "Embedded C & RTOS - internal",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2600000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 166600,
        "Status": "Closed",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Shruti Gupta",
        "Recruiter name": "Bhawna/Mahima"
    },
    {
        "Sr.No": 144,
        "Position received date": "27-Feb-25",
        "Clarity call date": "18-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "17-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "16-Apr-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Amal Ashok",
        "Position Name": "Embedded C & RTOS & Bare metal -Customer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "(15-26/28) LPA",
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Shruti Gupta",
        "Recruiter name": "Bhawna/Mahima"
    },
    {
        "Sr.No": 145,
        "Position received date": "27-Feb-25",
        "Clarity call date": "18-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "17-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "16-Apr-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Amal Ashok",
        "Position Name": "Embedded C & RTOS & Bare metal -Customer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "(15-26/28) LPA",
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Shruti Gupta",
        "Recruiter name": "Bhawna"
    },
    {
        "Sr.No": 146,
        "Position received date": "17-Feb-25",
        "Clarity call date": "17-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-Apr-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Amal Ashok",
        "Position Name": "Embedded C++ & Linux - Internal",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "25LPA",
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "1 cv fb pending, need to share the checklist",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Sriram",
        "Recruiter name": "simran"
    },
    {
        "Sr.No": 147,
        "Position received date": "17-Feb-25",
        "Clarity call date": "17-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "09-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-Apr-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Amal Ashok",
        "Position Name": "Embedded C++ & Linux - Internal",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "20-33 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "2 cv fb pending, , need to share the checklist",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Sriram",
        "Recruiter name": "avneet"
    },
    {
        "Sr.No": 148,
        "Position received date": "17-Feb-25",
        "Clarity call date": "17-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "07-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "06-Apr-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Amal Ashok",
        "Position Name": "Senior Technical Lead (Emb C & C++ with Linux) - Internal",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "27.5- 39 LPA",
        "Billable CTC": 3000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "2 cv fb pending, 1 cv will share today",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Shruti Gupta",
        "Recruiter name": "Kausar / Bhawna"
    },
    {
        "Sr.No": 149,
        "Position received date": "17-Feb-25",
        "Clarity call date": "17-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "07-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "06-Apr-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Amal Ashok",
        "Position Name": "Senior Architect (Embedded C/C++ with Linux) - Internal",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "35 LPA- 51 LPA",
        "Billable CTC": 4000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "2 cv's will share today",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Shruti Gupta",
        "Recruiter name": "Kausar"
    },
    {
        "Sr.No": 150,
        "Position received date": "24-Feb-25",
        "Clarity call date": "24-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "11-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "14-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "13-Apr-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Amal Ashok",
        "Position Name": "Embedded developers: Microcontroller - Customers",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "20-30 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "3 cv's will share today",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Shruti Gupta",
        "Recruiter name": "Bhawna/Mahima"
    },
    {
        "Sr.No": 151,
        "Position received date": "24-Feb-25",
        "Clarity call date": "24-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "11-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "14-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "13-Apr-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Amal Ashok",
        "Position Name": "Embedded Tester - Customer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "(15-26/28) LPA",
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Shruti Gupta",
        "Recruiter name": "Kausar"
    },
    {
        "Sr.No": 152,
        "Position received date": "25-Feb-25",
        "Clarity call date": "25-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "17-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "16-Apr-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Amal Ashok",
        "Position Name": "Aero Requirement - Customer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "3X-4X (20-30 LPA)",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "Need to take clarity",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Sonal"
    },
    {
        "Sr.No": 153,
        "Position received date": "04-Mar-25",
        "Clarity call date": "04-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "19-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Due to delay and duplicity Mam said to hold on this client",
        "Select to offer TAT": 7,
        "Approx Offer date": "26-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "25-Apr-25",
        "Client": "ICRA",
        "HR name/HM": "Puja Jaiswal",
        "Position Name": "Financial Analyst - Python",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 LPA",
        "Billable CTC": 1350000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 154,
        "Position received date": "24-Feb-25",
        "Clarity call date": "25-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "15-Mar-25",
        "Official Notice Period": 90,
        "Approx DOJ": "13-Jun-25",
        "Client": "John Deere",
        "HR name/HM": "Vishal Rane",
        "Position Name": "Lead Engineer - ML(112985)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "25LPA",
        "Billable CTC": 2200000,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": " L1 in line need to add more Cv",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 155,
        "Position received date": "24-Feb-25",
        "Clarity call date": "25-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Mar-25",
        "Candidate Date of selection": "08-Apr-25",
        "Revised Target Date of Selection": "12-Mar-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "15-Mar-25",
        "Actual Offer date": "12-Apr-25",
        "Official Notice Period": 90,
        "Approx DOJ": "13-Jun-25",
        "Actual DOJ candidate will join": "26th May 25",
        "Client": "John Deere",
        "HR name/HM": "Vishal Rane",
        "Position Name": "Sr engineer  -ML ",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2500000,
        "Billable CTC": 2200000,
        "Commercial %": 0.07,
        "Billing amount per position": 154000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 154000.00000000003,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Gourav kumar atre",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 156,
        "Position received date": "17-Dec-24",
        "Clarity call date": "19-Dec-24",
        "Position renew date": "11-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "03-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "06-Jan-25",
        "Official Notice Period": 30,
        "Approx DOJ": "05-Feb-25",
        "Client": "John Deere",
        "HR name/HM": "Santosh Shelake/Chintan Patel",
        "Position Name": "ME Assembly",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1380000,
        "Billable CTC": 1340000,
        "Commercial %": 1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 157,
        "Position received date": "12-Feb-25",
        "Clarity call date": "14-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "04-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "03-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Oscar Sanchej/Rajeev kumar",
        "Position Name": "Supplier Quality Enginner",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2200000,
        "Billable CTC": 1800000,
        "Commercial %": 1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 158,
        "Position received date": "18-Feb-25",
        "Clarity call date": "19-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "09-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Kunal Kulkarni",
        "Position Name": "Embedded System/Software Engineer (Embedded C + Functional Safety)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1380000,
        "Billable CTC": 1340000,
        "Commercial %": 0.5,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 159,
        "Position received date": "19-Feb-25",
        "Clarity call date": "20-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Mar-25",
        "Candidate Date of selection": "18-Mar-25",
        "Revised Target Date of Selection": "07-Mar-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-Mar-25",
        "Actual Offer date": "20-Mar-25",
        "Official Notice Period": 90,
        "Approx DOJ": "08-Jun-25",
        "Actual DOJ candidate will join": "31-Mar-25",
        "Client": "John Deere",
        "HR name/HM": "Akash Agrawal",
        "Position Name": "Embeeded Software ",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1380000,
        "Billable CTC": 1340000,
        "Commercial %": 1,
        "Billing amount per position": 1340000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 1340000,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Rajshree",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 160,
        "Position received date": "20-Jan-25",
        "Clarity call date": "21-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "05-Feb-25",
        "Candidate Date of selection": "22-Jan-25",
        "Revised Target Date of Selection": "05-Feb-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "08-Feb-25",
        "Actual Offer date": "27-Jan-25",
        "Official Notice Period": 90,
        "Approx DOJ": "09-May-25",
        "Actual DOJ candidate will join": "28-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Eknath Pawar",
        "Position Name": "Graphics Design",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1380000,
        "Billable CTC": 1435559,
        "Commercial %": 0.08,
        "Billing amount per position": 114844.72,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 114844.72,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Purnima Batham",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 161,
        "Position received date": "08-Jan-25",
        "Clarity call date": "09-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "24-Jan-25",
        "Candidate Date of selection": "17-Jan-25",
        "Revised Target Date of Selection": "24-Jan-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "27-Jan-25",
        "Actual Offer date": "23-Jan-25",
        "Official Notice Period": 90,
        "Approx DOJ": "27-Apr-25",
        "Actual DOJ candidate will join": "17-Jan-25",
        "Client": "John Deere",
        "HR name/HM": "Amol Yerawar",
        "Position Name": "Design Driveline/Drivetrain",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1380000,
        "Billable CTC": 1435559,
        "Commercial %": 0.08,
        "Billing amount per position": 114844.72,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 114844.72,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Sonal Bhati",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 162,
        "Position received date": "23-Dec-24",
        "Clarity call date": "24-Dec-24",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-Jan-25",
        "Candidate Date of selection": "04-Mar-25",
        "Revised Target Date of Selection": "08-Jan-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "11-Jan-25",
        "Actual Offer date": "11-Dec-24",
        "Official Notice Period": 90,
        "Approx DOJ": "11-Apr-25",
        "Actual DOJ candidate will join": "04-Dec-24",
        "Client": "John Deere",
        "HR name/HM": "Lakesh Bisen",
        "Position Name": "TIS",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1380000,
        "Billable CTC": 1443558,
        "Commercial %": 0.07,
        "Billing amount per position": 101049.06000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 101049.06000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Vivek Kumar Singh",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 163,
        "Position received date": "09-Jan-25",
        "Clarity call date": "09-Jan-25",
        "Position renew date": "28-Jan-25",
        "TAT to selection as per SLA": 7,
        "Target Date of Selection": "16-Jan-25",
        "Candidate Date of selection": "22-Mar-25",
        "Revised Target Date of Selection": "16-Jan-25",
        "Reason of delay/HOLD": "Candiate no show and panel no show",
        "Select to offer TAT": 2,
        "Approx Offer date": "18-Jan-25",
        "Actual Offer date": "18-Feb-25",
        "Official Notice Period": 0,
        "Approx DOJ": "18-Jan-25",
        "Actual DOJ candidate will join": "18th Feb'25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Python AWS",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1200000,
        "Billable CTC": 1200000,
        "Commercial %": 0.075,
        "Billing amount per position": 90000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 90000,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Selected candidate name": "Gautami Gamre",
        "Recruiter name": "Megha Patel"
    },
    {
        "Sr.No": 164,
        "Position received date": "09-Jan-25",
        "Clarity call date": "09-Jan-25",
        "Position renew date": "28-Jan-25",
        "TAT to selection as per SLA": 7,
        "Target Date of Selection": "16-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Candiate no show and panel no show",
        "Select to offer TAT": 2,
        "Approx Offer date": "18-Jan-25",
        "Official Notice Period": 0,
        "Approx DOJ": "18-Jan-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Python AWS (6-8 Years)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1200000,
        "Billable CTC": 1200000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Megha Patel"
    },
    {
        "Sr.No": 165,
        "Position received date": "16-Jan-25",
        "Clarity call date": "16-Jan-25",
        "Position renew date": "-",
        "TAT to selection as per SLA": 7,
        "Target Date of Selection": "23-Jan-25",
        "Candidate Date of selection": "08-Apr-25",
        "Revised Target Date of Selection": "23-Jan-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "25-Jan-25",
        "Actual Offer date": "26-Feb-25",
        "Official Notice Period": 15,
        "Approx DOJ": "09-Feb-25",
        "Actual DOJ candidate will join": "27th Feb'25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "DevOps AWS",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2600000,
        "Billable CTC": 2600000,
        "Commercial %": 0.075,
        "Billing amount per position": 195000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 195000,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Selected candidate name": "Pratik Argade",
        "Recruiter name": "Khadija Panvelwala"
    },
    {
        "Sr.No": 166,
        "Position received date": "14-Jan-25",
        "Clarity call date": "14-Jan-25",
        "Position renew date": "-",
        "TAT to selection as per SLA": 7,
        "Target Date of Selection": "21-Jan-25",
        "Candidate Date of selection": "13-Apr-25",
        "Revised Target Date of Selection": "21-Jan-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "23-Jan-25",
        "Actual Offer date": "13-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "22-Feb-25",
        "Actual DOJ candidate will join": "20th Mar'25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "PHP Developer(4-6Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1700000,
        "Billable CTC": 1700000,
        "Commercial %": 0.075,
        "Billing amount per position": 127500,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 127500,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Selected candidate name": "Nilesh Swami",
        "Recruiter name": "Megha Patel"
    },
    {
        "Sr.No": 167,
        "Position received date": "14-Jan-25",
        "Clarity call date": "14-Jan-25",
        "Position renew date": "-",
        "TAT to selection as per SLA": 7,
        "Target Date of Selection": "21-Jan-25",
        "Candidate Date of selection": "04-Apr-25",
        "Revised Target Date of Selection": "21-Jan-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "23-Jan-25",
        "Official Notice Period": 30,
        "Approx DOJ": "22-Feb-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "PHP Developer(4-6Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1600000,
        "Billable CTC": 1600000,
        "Commercial %": 0.075,
        "Billing amount per position": 120000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 120000,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Selected candidate name": "Krishna Namdev",
        "Recruiter name": "Disha "
    },
    {
        "Sr.No": 168,
        "Position received date": "09-Jan-25",
        "Clarity call date": "09-Jan-25",
        "TAT to selection as per SLA": 7,
        "Target Date of Selection": "16-Jan-25",
        "Candidate Date of selection": "28-Mar-25",
        "Revised Target Date of Selection": "16-Jan-25",
        "Reason of delay/HOLD": "High Duplicacy, 4 vendors and 7 recruiters working on same role",
        "Select to offer TAT": 2,
        "Approx Offer date": "18-Jan-25",
        "Actual Offer date": "30-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-Feb-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Java AWS Developer(6-8Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1700000,
        "Billable CTC": 1700000,
        "Commercial %": 0.075,
        "Billing amount per position": 127500,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 127500,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Selected candidate name": "Ashwin Kamble",
        "Recruiter name": "Khadija Panvelwala"
    },
    {
        "Sr.No": 169,
        "Position received date": "09-Jan-25",
        "Clarity call date": "09-Jan-25",
        "TAT to selection as per SLA": 7,
        "Target Date of Selection": "16-Jan-25",
        "Candidate Date of selection": "21-Feb-25",
        "Revised Target Date of Selection": "16-Jan-25",
        "Reason of delay/HOLD": "High Duplicacy, 4 vendors and 7 recruiters working on same role",
        "Select to offer TAT": 2,
        "Approx Offer date": "18-Jan-25",
        "Actual Offer date": "17-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-Feb-25",
        "Actual DOJ candidate will join": "17-Mar-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Java AWS Developer(8-10Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 3000000,
        "Billable CTC": 3800000,
        "Commercial %": 0.075,
        "Billing amount per position": 285000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 285000,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Selected candidate name": "Shivtej Sumbe",
        "Recruiter name": "Khadija Panvelwala"
    },
    {
        "Sr.No": 170,
        "Position received date": "11-May-25",
        "Clarity call date": "11-May-25",
        "TAT to selection as per SLA": 7,
        "Target Date of Selection": "18-May-25",
        "Candidate Date of selection": "13-May-25",
        "Revised Target Date of Selection": "18-May-25",
        "Reason of delay/HOLD": "High Duplicacy, 4 vendors and 7 recruiters working on same role",
        "Select to offer TAT": 2,
        "Approx Offer date": "20-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "19-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Java AWS Developer(8-10Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 3000000,
        "Billable CTC": 3000000,
        "Commercial %": 0.075,
        "Billing amount per position": 225000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 225000,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Selected candidate name": "Akash Desai",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 171,
        "Position received date": "03-Feb-25",
        "Clarity call date": "03-Feb-25",
        "TAT to selection as per SLA": 7,
        "Target Date of Selection": "10-Feb-25",
        "Candidate Date of selection": "18-Mar-25",
        "Revised Target Date of Selection": "10-Feb-25",
        "Reason of delay/HOLD": "High Duplicacy, 4 vendors and 7 recruiters working on same role",
        "Select to offer TAT": 2,
        "Approx Offer date": "12-Feb-25",
        "Actual Offer date": "12-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Mar-25",
        "Actual DOJ candidate will join": "12-Mar-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Dotnet Athoc Developer(2-4Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1200000,
        "Billable CTC": 1200000,
        "Commercial %": 0.075,
        "Billing amount per position": 90000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 90000,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Selected candidate name": "Shrutesh Thorve",
        "Recruiter name": "Khadija Panvelwala"
    },
    {
        "Sr.No": 172,
        "Position received date": "03-Feb-25",
        "Clarity call date": "03-Feb-25",
        "TAT to selection as per SLA": 7,
        "Target Date of Selection": "10-Feb-25",
        "Candidate Date of selection": "12-Jan-25",
        "Revised Target Date of Selection": "10-Feb-25",
        "Reason of delay/HOLD": "High Duplicacy, 4 vendors and 7 recruiters working on same role",
        "Select to offer TAT": 2,
        "Approx Offer date": "12-Feb-25",
        "Actual Offer date": "28-Mar-25",
        "Official Notice Period": 7,
        "Approx DOJ": "19-Feb-25",
        "Actual DOJ candidate will join": "28-Mar-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Dotnet Athoc Developer(4-6Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2200000,
        "Billable CTC": 2200000,
        "Commercial %": 0.075,
        "Billing amount per position": 165000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 165000,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Selected candidate name": "Sneha Tiwari",
        "Recruiter name": "Khadija Panvelwala"
    },
    {
        "Sr.No": 173,
        "Position received date": "25-Mar-25",
        "Clarity call date": "25-Mar-25",
        "TAT to selection as per SLA": 7,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "High Duplicacy, 4 vendors and 7 recruiters working on same role",
        "Select to offer TAT": 2,
        "Approx Offer date": "03-Apr-25",
        "Actual Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "03-May-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Dotnet/Adv Javascript Developer(4-8Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 3300000,
        "Billable CTC": 3300000,
        "Commercial %": 0.075,
        "Billing amount per position": 247500,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 247500,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Selected candidate name": "Puspendra Dwivedi",
        "Recruiter name": "monika"
    },
    {
        "Sr.No": 174,
        "Position received date": "04-Mar-25",
        "Clarity call date": "05-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "niche position and duplicity",
        "Select to offer TAT": 7,
        "Approx Offer date": "27-Mar-25",
        "Official Notice Period": 90,
        "Approx DOJ": "25-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "Cell manufacturing process simulations",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1600000,
        "Billable CTC": 1400000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama"
    },
    {
        "Sr.No": 175,
        "Position received date": "04-Mar-25",
        "Clarity call date": "05-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "They need to hire Sr.candidate hence they have kept junior role on hold",
        "Select to offer TAT": 7,
        "Approx Offer date": "27-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "26-May-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": ".Lead Cell Modelling",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 3700000,
        "Billable CTC": 300000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama"
    },
    {
        "Sr.No": 176,
        "Position received date": "04-Mar-25",
        "Clarity call date": "05-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "On hold as per global stakeholder",
        "Select to offer TAT": 7,
        "Approx Offer date": "27-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "26-Apr-25",
        "Client": "Brembo brakes",
        "HR name/HM": "Khalid Pathan",
        "Position Name": "Senior Engineer – Process Quality",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 900000,
        "Billable CTC": 900000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 177,
        "Position received date": "04-Mar-25",
        "Clarity call date": "05-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "On hold as per global stakeholder",
        "Select to offer TAT": 7,
        "Approx Offer date": "27-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "26-Apr-25",
        "Client": "Brembo brakes",
        "HR name/HM": "Khalid Pathan",
        "Position Name": "Executive – Customer Logistics",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 900000,
        "Billable CTC": 900000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 178,
        "Position received date": "05-Mar-25",
        "Clarity call date": "05-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback Delay",
        "Select to offer TAT": 7,
        "Approx Offer date": "27-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "26-Apr-25",
        "Client": "Endurance",
        "HR name/HM": "Nidhi Naik",
        "Position Name": "Manufacturing Head",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2600000,
        "Billable CTC": 2600000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 179,
        "Position received date": "18-Feb-25",
        "Clarity call date": "20-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "14-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "13-Apr-25",
        "Client": "ApplusIDadia",
        "HR name/HM": "Sneha Kota",
        "Position Name": "Technical Project /Program Manager",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 180,
        "Position received date": "25-Feb-25",
        "Clarity call date": "28-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "15-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "22-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "21-Apr-25",
        "Client": "LNT-Construction",
        "HR name/HM": "Danya Dasan",
        "Position Name": "Cost Accountant",
        "Number of Positions": 6,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1380000,
        "Billable CTC": 1340000,
        "Commercial %": 0.5,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran Gupta"
    },
    {
        "Sr.No": 181,
        "Position received date": "25-Feb-25",
        "Clarity call date": "28-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "15-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "22-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "21-Apr-25",
        "Client": "LNT-Construction",
        "HR name/HM": "Danya Dasan",
        "Position Name": "IR",
        "Number of Positions": 4,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1380000,
        "Billable CTC": 1340000,
        "Commercial %": 1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran Gupta"
    },
    {
        "Sr.No": 182,
        "Position received date": "07-Mar-25",
        "Clarity call date": "07-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "29-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "28-Apr-25",
        "Client": "SRDI",
        "HR name/HM": "Amitesh Parihar",
        "Position Name": "ADAS",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1380000,
        "Billable CTC": 1340000,
        "Commercial %": 0.0666,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran Gupta"
    },
    {
        "Sr.No": 183,
        "Position received date": "12-Mar-25",
        "Clarity call date": "12-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "27-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback Delay",
        "Select to offer TAT": 7,
        "Approx Offer date": "03-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "02-Jun-25",
        "Client": "Endurance",
        "HR name/HM": "Nidhi Naik",
        "Position Name": "Quality Head",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2600000,
        "Billable CTC": 2600000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 184,
        "Position received date": "10-Mar-25",
        "Clarity call date": "10-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Due to delay and duplicity Mam said to hold on this client",
        "Select to offer TAT": 7,
        "Approx Offer date": "01-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "01-May-25",
        "Client": "ICRA",
        "HR name/HM": "Puja Jaiswal",
        "Position Name": "Financial Analyst - Python",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 LPA",
        "Billable CTC": 1350000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 185,
        "Position received date": "07-Mar-25",
        "Clarity call date": "07-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Due to delay and duplicity Mam said to hold on this client",
        "Select to offer TAT": 7,
        "Approx Offer date": "29-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "28-Apr-25",
        "Client": "ICRA",
        "HR name/HM": "Liza Paul",
        "Position Name": "Sr.Engineer-Quality Automation",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 LPA",
        "Billable CTC": 1350000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 186,
        "Position received date": "07-Mar-25",
        "Clarity call date": "07-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Challenge in getting candidates from OEM with full venhicle integration ADAS expereince and they need less notice period",
        "Select to offer TAT": 7,
        "Approx Offer date": "29-Mar-25",
        "Official Notice Period": 60,
        "Approx DOJ": "28-May-25",
        "Client": "SRDI",
        "HR name/HM": "Amitesh Parihar",
        "Position Name": "ADAS Lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1380000,
        "Billable CTC": 1340000,
        "Commercial %": 0.0666,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 187,
        "Position received date": "13-Mar-25",
        "Clarity call date": "13-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "28-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "On hold as per global stakeholder",
        "Select to offer TAT": 7,
        "Approx Offer date": "04-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "04-May-25",
        "Client": "Brembo brakes",
        "HR name/HM": "Khalid Pathan",
        "Position Name": "Indirect Purchase ",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 900000,
        "Billable CTC": 900000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 188,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position given to multiple vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "Embedded Test, Industrial",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "45 -56 LPA",
        "Billable CTC": 5000000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 189,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "they have pipeline from another vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "C++, Linux, IoT",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "28-35 LPA",
        "Billable CTC": 3200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 190,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position given to multiple vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "C++, BSP",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "28-35 LPA",
        "Billable CTC": 3200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 191,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position given to multiple vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "Embedded Test, HVAC",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "28-35 LPA",
        "Billable CTC": 3200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 192,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position given to multiple vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "C +L2 L3 Network Developer - Internal",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 193,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position given to multiple vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "C +L2 L3 Network Developer - Internal",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 194,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position given to multiple vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "C +L2 L3 Network Developer - Internal",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 195,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position given to multiple vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "C +L2 L3 Network Developer - Client",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 196,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position given to multiple vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "C +L2 L3 Network Developer - Client",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 197,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position given to multiple vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "C +L2 L3 Network Developer - Client",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "10-17 LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 198,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position given to multiple vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "C +L2 L3 Network Developer - Client",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "45 -56 LPA",
        "Billable CTC": 5000000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 199,
        "Position received date": "13-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Position given to multiple vendor",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Nitish v",
        "Position Name": "C +L2 L3 Network Developer - Client",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "35-45 LPA",
        "Billable CTC": 4000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 200,
        "Position received date": "17-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Swathi Maddikayala",
        "Position Name": "Module Test Lead - C3 ",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2600000,
        "Billable CTC": 2600000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Bhagyashree"
    },
    {
        "Sr.No": 201,
        "Position received date": "17-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Swathi Maddikayala",
        "Position Name": "Module Test Lead - C3 ",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2600000,
        "Billable CTC": 2600000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Bhagyashree"
    },
    {
        "Sr.No": 202,
        "Position received date": "17-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Swathi Maddikayala",
        "Position Name": "Test Lead / Architect - C3 ",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 4000000,
        "Billable CTC": 4000000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Bhagyashree"
    },
    {
        "Sr.No": 203,
        "Position received date": "17-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "08-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Swathi Maddikayala",
        "Position Name": "Test Lead / Architect - C3 ",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 4000000,
        "Billable CTC": 4000000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Bhagyashree"
    },
    {
        "Sr.No": 204,
        "Position received date": "11-Mar-25",
        "Clarity call date": "11-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "26-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "29-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "28-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Madhusudan",
        "Position Name": "CVML - C++ Developer - G6",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "24 LPA",
        "Billable CTC": 2200000,
        "Commercial %": 0.07,
        "Billing amount per position": 154000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 154000.00000000003,
        "Status": "Active",
        "Current delivery update": "4 CV feedback Pending, 4 cv pending - posn got closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Gupta"
    },
    {
        "Sr.No": 205,
        "Position received date": "11-Mar-25",
        "Clarity call date": "11-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "26-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "29-Mar-25",
        "Official Notice Period": 30,
        "Approx DOJ": "28-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Madhusudan",
        "Position Name": "CVML - C++ Developer, CV or ML OR DL  - G7",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "35LPA",
        "Billable CTC": 3200000,
        "Commercial %": 0.07,
        "Billing amount per position": 224000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 224000.00000000003,
        "Status": "Active",
        "Current delivery update": "1 L1 inline for 24th Mar'25",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Shruti Gupta"
    },
    {
        "Sr.No": 206,
        "Position received date": "17-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "04-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "04-May-25",
        "Client": "John Deere",
        "HR name/HM": "Abhisar Sahoo",
        "Position Name": "Sr.Engineer-Legal",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "18.1 LPA",
        "Billable CTC": 1720000,
        "Commercial %": 0.07,
        "Billing amount per position": 120400.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 120400.00000000001,
        "Status": "Active",
        "Current delivery update": "4 L2 to be schedule , need to serve",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama/Disha"
    },
    {
        "Sr.No": 207,
        "Position received date": "19-Mar-25",
        "Clarity call date": "19-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "03-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Ctc issue and need immediate joiners",
        "Select to offer TAT": 7,
        "Approx Offer date": "10-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "10-May-25",
        "Client": "HP",
        "HR name/HM": "Rakshita Banjan",
        "Position Name": "Production Engineer",
        "Number of Positions": 5,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 3500000,
        "Billable CTC": 3000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 208,
        "Position received date": "20-Mar-25",
        "Clarity call date": "20-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback Delay",
        "Select to offer TAT": 7,
        "Approx Offer date": "11-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "10-Jun-25",
        "Client": "Endurance",
        "HR name/HM": "Harsha Vardhan",
        "Position Name": "Market Research Analyst",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "12.5 LPA",
        "Billable CTC": 1180000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "1 L2 to be schedule",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Ramya"
    },
    {
        "Sr.No": 210,
        "Position received date": "20-Mar-25",
        "Clarity call date": "24-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-Apr-25",
        "Candidate Date of selection": "12-May-25",
        "Revised Target Date of Selection": "08-Apr-25",
        "Reason of delay/HOLD": "SOP alogorithm development candidates are less in the market, position is niche hence not able to find the relevant pool 7 Duplicity",
        "Select to offer TAT": 3,
        "Approx Offer date": "11-Apr-25",
        "Actual Offer date": "15-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "10-Jul-25",
        "Actual DOJ candidate will join": "18-Aug-25",
        "Client": "John Deere",
        "HR name/HM": "Sivaprakash Palaniswamy",
        "Position Name": "Supplier Quality-Metal fabrication",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "19.6 LPA",
        "Billable CTC": 1880000,
        "Commercial %": 0.07,
        "Billing amount per position": 131600,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 131600,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Selected candidate name": "Akshay Dnyaneshwar  ",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 211,
        "Position received date": "21-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "Module Lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 212,
        "Position received date": "21-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "Module Lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 213,
        "Position received date": "21-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "SENIOR SOFTWARE ENGINEER - DEVELOPER",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "10-17 LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 214,
        "Position received date": "21-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "SENIOR TECHNICAL LEAD - SENIOR LEAD",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "35-45 LPA",
        "Billable CTC": 4000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 215,
        "Position received date": "21-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "SENIOR TEST ARCHITECT - SENIOR ARCHITECT",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "45 -56 LPA",
        "Billable CTC": 5000000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 216,
        "Position received date": "21-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "TEST LEAD - LEAD",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "28-35 LPA",
        "Billable CTC": 3200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 217,
        "Position received date": "21-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "Module Lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Ramya"
    },
    {
        "Sr.No": 218,
        "Position received date": "21-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "Module Lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Ramya"
    },
    {
        "Sr.No": 219,
        "Position received date": "21-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "TEST MODULE LEAD - LEAD",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 220,
        "Position received date": "21-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "SENIOR ARCHITECT ",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "45 -56 LPA",
        "Billable CTC": 5000000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 221,
        "Position received date": "26-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Duplicity",
        "Select to offer TAT": 5,
        "Approx Offer date": "15-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "14-Jun-25",
        "Client": "TDK",
        "HR name/HM": "Ankita Khandelwal",
        "Position Name": "Sales Support",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "14-15 LPA",
        "Billable CTC": 13500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 222,
        "Position received date": "19-Mar-25",
        "Clarity call date": "19-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "03-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Duplicity",
        "Select to offer TAT": 5,
        "Approx Offer date": "08-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "07-Jun-25",
        "Client": "TDK",
        "HR name/HM": "Ankita Khandelwal",
        "Position Name": "Automotive Sales",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "14-15 LPA",
        "Billable CTC": 13500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 223,
        "Position received date": "21-Mar-25",
        "Clarity call date": "24-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-Apr-25",
        "Candidate Date of selection": "17-Apr-25",
        "Revised Target Date of Selection": "08-Apr-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "11-Apr-25",
        "Actual Offer date": "23-Apr-25",
        "Official Notice Period": 90,
        "Approx DOJ": "10-Jul-25",
        "Actual DOJ candidate will join": "21-Jun-25",
        "Client": "John Deere",
        "HR name/HM": "Rajeev kumar",
        "Position Name": "Supplier Quality",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2000000,
        "Billable CTC": 2000000,
        "Commercial %": 0.07,
        "Billing amount per position": 140000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 140000,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Prawal Kumar Srivastava",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 224,
        "Position received date": "13-Jan-25",
        "Clarity call date": "15-Jan-25",
        "Position renew date": "24-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "30-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "need to plan sourcing call",
        "Select to offer TAT": 3,
        "Approx Offer date": "02-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "03-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Chandrasekhar Barai/Shrirang Phate",
        "Position Name": "MBD Builder",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2000000,
        "Billable CTC": 2000000,
        "Commercial %": 0.07,
        "Billing amount per position": 140000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 140000,
        "Status": "Active",
        "Current delivery update": "need to plan sourcing call",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 225,
        "Position received date": "13-Jan-25",
        "Clarity call date": "15-Jan-25",
        "Position renew date": "24-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "30-Jan-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "02-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "03-Apr-25",
        "Client": "John Deere",
        "Position Name": "MBD User",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2000000,
        "Billable CTC": 2000000,
        "Commercial %": 0.07,
        "Billing amount per position": 140000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 140000,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 226,
        "Position received date": "26-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Candidate Date of selection": "02-Apr-25",
        "Revised Target Date of Selection": "10-Apr-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "13-Apr-25",
        "Actual Offer date": "07-Apr-25",
        "Official Notice Period": 90,
        "Approx DOJ": "12-Jul-25",
        "Actual DOJ candidate will join": "07-Jul-25",
        "Client": "John Deere",
        "HR name/HM": "Sunny Gaikwad",
        "Position Name": "Embedded Software (Embedded C)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 2000000,
        "Commercial %": 0.07,
        "Billing amount per position": 140000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 140000,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Rahul S. Vajire",
        "Recruiter name": "Simran Gupta"
    },
    {
        "Sr.No": 227,
        "Position received date": "26-Mar-25",
        "Clarity call date": "24-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-Apr-25",
        "Candidate Date of selection": "28-Apr-25",
        "Revised Target Date of Selection": "08-Apr-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "11-Apr-25",
        "Actual Offer date": "02-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "10-Jul-25",
        "Actual DOJ candidate will join": "25-Jul-25",
        "Client": "John Deere",
        "HR name/HM": "Jothiprakash",
        "Position Name": "ME Machining (CNC Programmimg)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1600000,
        "Commercial %": 0.07,
        "Billing amount per position": 112000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 112000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Shubham shriramji katkar",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 228,
        "Position received date": "27-Mar-25",
        "Clarity call date": "31-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "15-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "22-Apr-25",
        "Official Notice Period": 90,
        "Approx DOJ": "21-Jul-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "Manager – IT Apps Operations (Corporate)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18.5 LPA",
        "Billable CTC": 1750000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "2 L2 to be schduled, 2 cvs feedback pending",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 229,
        "Position received date": "27-Mar-25",
        "Clarity call date": "02-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "17-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "24-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "23-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "Manager – Manufacturing & Quality",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18.5 LPA",
        "Billable CTC": 1750000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "Need to arrange call with the HM",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama"
    },
    {
        "Sr.No": 230,
        "Position received date": "27-Mar-25",
        "Clarity call date": "27-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "11-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Positionis on -Internal disucssion going on",
        "Select to offer TAT": 7,
        "Approx Offer date": "18-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "17-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "Deputy General Manager – Supply Chain IT BP for Procurement",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "40 LPA",
        "Billable CTC": 3200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 231,
        "Position received date": "27-Mar-25",
        "Clarity call date": "02-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "17-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "24-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "23-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "Manager – IT Supply Chain Finance",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18.5 LPA",
        "Billable CTC": 1750000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "Need to arrange call with the HM",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 232,
        "Position received date": "27-Mar-25",
        "Clarity call date": "27-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "11-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "18-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "17-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Sonali Phalke",
        "Position Name": "General Manager IT – COE Sc and Technology",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "60 LPA",
        "Billable CTC": 5200000,
        "Commercial %": 0.12,
        "Billing amount per position": 624000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 624000,
        "Status": "Active",
        "Current delivery update": "1 L1 feedback pending, 1 L2 schedule on 17th Jun, Need to serve",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama/Aashi"
    },
    {
        "Sr.No": 233,
        "Position received date": "31-Mar-25",
        "Clarity call date": "01-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "16-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "23-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "22-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "Manager IT – IT BP R&D Tools",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18.5 LPA",
        "Billable CTC": 1750000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "kartick"
    },
    {
        "Sr.No": 234,
        "Position received date": "31-Mar-25",
        "Clarity call date": "01-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "16-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "23-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "22-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Sonali Phalke",
        "Position Name": "Senior IT Manager – IT BP LIMS",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "18.5 LPA",
        "Billable CTC": 1750000,
        "Commercial %": 0.0833,
        "Billing amount per position": 145775,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 145775,
        "Status": "Active",
        "Current delivery update": "1 HRBP round schedule on 13th Jun",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama"
    },
    {
        "Sr.No": 235,
        "Position received date": "31-Mar-25",
        "Clarity call date": "31-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "15-Apr-25",
        "Candidate Date of selection": "30-Apr-25",
        "Revised Target Date of Selection": "15-Apr-25",
        "Reason of delay/HOLD": "Getting slots from Jayant & Rajeev Sir was a challenge",
        "Select to offer TAT": 7,
        "Approx Offer date": "22-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "21-Jun-25",
        "Client": "HP",
        "HR name/HM": "Hema Obhan",
        "Position Name": "SAP FICO",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2000000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 166600,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Disha",
        "Selected candidate name": "Praveen Jethaliya",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 236,
        "Position received date": "20-Mar-25",
        "Clarity call date": "20-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "11-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "10-Jun-25",
        "Client": "HP",
        "HR name/HM": "Hema Obhan",
        "Position Name": "SAP PP",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "15 LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "1 L1 in line(4th April), Need to serve",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Disha",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 237,
        "Position received date": "26-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "Module lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 238,
        "Position received date": "26-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "Module lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 239,
        "Position received date": "26-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "Module lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Sriram"
    },
    {
        "Sr.No": 240,
        "Position received date": "26-Mar-25",
        "Clarity call date": "26-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-Apr-25",
        "Official Notice Period": 30,
        "Approx DOJ": "17-May-25",
        "Client": "Happiest Minds",
        "HR name/HM": "Sriram",
        "Position Name": "Test Module lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "17-28 LPA",
        "Billable CTC": 2500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 241,
        "Position received date": "25-Mar-25",
        "Clarity call date": "25-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "09-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "16-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "15-Jun-25",
        "Client": "India Cements",
        "HR name/HM": "Saranya. D",
        "Position Name": "Head - Marketing & Channel Development",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "45 LPA ",
        "Billable CTC": 3900000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Disha",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 242,
        "Position received date": "08-Apr-25",
        "Clarity call date": "08-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "23-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "30-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "29-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "Mgr – Security Operations",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18.5 LPA",
        "Billable CTC": 1750000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "Need to arrange call with the HM",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama"
    },
    {
        "Sr.No": 243,
        "Position received date": "08-Apr-25",
        "Clarity call date": "08-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "23-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "30-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "29-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "Mgr - Cyber Compliance",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18.5 LPA",
        "Billable CTC": 1750000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "Need to arrange call with the HM",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama"
    },
    {
        "Sr.No": 244,
        "Position received date": "26-Mar-25",
        "Clarity call date": "28-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "19-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "18-Jun-25",
        "Client": "SRDI",
        "HR name/HM": "Monali Mazumdar",
        "Position Name": "DGM HR",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 7500000,
        "Billable CTC": 6500000,
        "Commercial %": 0.0666,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "need to serve",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 245,
        "Position received date": "26-Mar-25",
        "Clarity call date": "28-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "19-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "18-Jun-25",
        "Client": "SRDI",
        "HR name/HM": "Monali Mazumdar",
        "Position Name": "HR Executive",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2300000,
        "Billable CTC": 1800000,
        "Commercial %": 0.0666,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "2 L2 TBS- SLot pending",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 246,
        "Position received date": "26-Mar-25",
        "Clarity call date": "28-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "19-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "18-Jun-25",
        "Client": "SRDI",
        "HR name/HM": "Monali Mazumdar",
        "Position Name": "DGM Finance",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 7500000,
        "Billable CTC": 6500000,
        "Commercial %": 0.0666,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "2 cvs shared",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 247,
        "Position received date": "26-Mar-25",
        "Clarity call date": "28-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "19-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "18-Jun-25",
        "Client": "SRDI",
        "HR name/HM": "Monali Mazumdar",
        "Position Name": "Finance Executive",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1500000,
        "Billable CTC": 1000000,
        "Commercial %": 0.0666,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "need to serve as need to take leavay",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 248,
        "Position received date": "17-Apr-25",
        "Clarity call date": "17-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Feedback Delay",
        "Select to offer TAT": 7,
        "Approx Offer date": "09-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "07-Aug-25",
        "Client": "Endurance",
        "HR name/HM": "Shalini Raj",
        "Position Name": "KEM",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "24LPA",
        "Billable CTC": 2000000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "5 cvs feedback pending",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 249,
        "Position received date": "09-Apr-25",
        "Clarity call date": "09-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "24-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "01-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "30-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Pankaj Kajal",
        "Position Name": "VP/Head – Construction Program Management",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "1.2 Cr",
        "Billable CTC": 8500000,
        "Commercial %": 0.12,
        "Billing amount per position": 1020000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 1020000,
        "Status": "Active",
        "Current delivery update": "2 HRBP to be schedule",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama/Aashi"
    },
    {
        "Sr.No": 250,
        "Position received date": "24-Apr-25",
        "Clarity call date": "24-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "09-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "16-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "15-Jul-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "ALM PLM Enablement and Adoption lead ",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "45 LPA",
        "Billable CTC": 3500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 291550,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 291550,
        "Status": "Active",
        "Current delivery update": "1 L2 to be schedule, 1 L1 feedback pending, 4 cvs feedback pending",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama/Shenaaz"
    },
    {
        "Sr.No": 251,
        "Position received date": "28-Apr-25",
        "Clarity call date": "28-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "20-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "19-Jul-25",
        "Client": "Agratas",
        "HR name/HM": "Pragna Balaraju",
        "Position Name": "Team Member - ITBP Corporate Apps",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "18.5 LPA",
        "Billable CTC": 1750000,
        "Commercial %": 0.0833,
        "Billing amount per position": 145775,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 145775,
        "Status": "Active",
        "Current delivery update": "1 L1 on hold, 4 cvs feedback pending",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 252,
        "Position received date": "22-Jan-25",
        "Clarity call date": "23-Jan-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Feb-25",
        "Candidate Date of selection": "14-Feb-25",
        "Revised Target Date of Selection": "07-Feb-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-Feb-25",
        "Actual Offer date": "18-Feb-25",
        "Official Notice Period": 60,
        "Approx DOJ": "11-Apr-25",
        "Actual DOJ candidate will join": "23-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Kishor Chandoba",
        "Position Name": "Assembly Quality",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1600000,
        "Commercial %": 0.07,
        "Billing amount per position": 112000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 112000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Mitali Madhukar Tekade",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 253,
        "Position received date": "12-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Candidate Date of selection": "08-Apr-25",
        "Revised Target Date of Selection": "01-Apr-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "04-Apr-25",
        "Actual Offer date": "04-Apr-25",
        "Official Notice Period": 15,
        "Approx DOJ": "19-Apr-25",
        "Actual DOJ candidate will join": "04-Apr-25",
        "Client": "John Deere",
        "HR name/HM": "Santosh Shelake/Chintan Patel/Veeresh/Balasaheb",
        "Position Name": "ME Assembly",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1600000,
        "Commercial %": 0.07,
        "Billing amount per position": 112000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 112000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Anup Chaki",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 254,
        "Position received date": "12-Mar-25",
        "Clarity call date": "17-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "01-Apr-25",
        "Candidate Date of selection": "23-May-25",
        "Revised Target Date of Selection": "01-Apr-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "04-Apr-25",
        "Actual Offer date": "28th May'25",
        "Official Notice Period": 60,
        "Approx DOJ": "03-Jun-25",
        "Actual DOJ candidate will join": "01-Sep-25",
        "Client": "John Deere",
        "HR name/HM": "Santosh Hargunani",
        "Position Name": "FEA Analyst",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1902828,
        "Commercial %": 0.07,
        "Billing amount per position": 133197.96000000002,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 133197.96000000002,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Ankush Bapuso Khot",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 255,
        "Position received date": "02-Apr-25",
        "Clarity call date": "07-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "he was looking for internal camdidate parallely",
        "Select to offer TAT": 3,
        "Approx Offer date": "25-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "24-Jun-25",
        "Client": "John Deere",
        "HR name/HM": "Chinmaya Mohapatra",
        "Position Name": "ME TFD",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 1380000,
        "Commercial %": 0.07,
        "Billing amount per position": 96600.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 96600.00000000001,
        "Status": "Active",
        "Current delivery update": "3 L1 Fb pending",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 256,
        "Position received date": "02-Apr-25",
        "Clarity call date": "07-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Apr-25",
        "Candidate Date of selection": "22-Feb-25",
        "Revised Target Date of Selection": "22-Apr-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "25-Apr-25",
        "Actual Offer date": "09-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "24-Jun-25",
        "Actual DOJ candidate will join": "11-Aug-25",
        "Client": "John Deere",
        "HR name/HM": "Omkar Hawal",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1600000,
        "Commercial %": 0.07,
        "Billing amount per position": 112000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 112000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Swapnil Balwant Bhagat",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 257,
        "Position received date": "03-Apr-25",
        "Clarity call date": "07-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Apr-25",
        "Candidate Date of selection": "28-Apr-25",
        "Revised Target Date of Selection": "22-Apr-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "25-Apr-25",
        "Actual Offer date": "20-Apr-25",
        "Official Notice Period": 90,
        "Approx DOJ": "24-Jul-25",
        "Actual DOJ candidate will join": "25-Aug-25",
        "Client": "John Deere",
        "HR name/HM": "Saurabh Bhandari",
        "Position Name": "ME Weld",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1600000,
        "Commercial %": 0.07,
        "Billing amount per position": 112000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 112000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Akshar Shyamkant Vasekar",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 258,
        "Position received date": "04-Apr-25",
        "Clarity call date": "07-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Apr-25",
        "Candidate Date of selection": "11-Jun-25",
        "Revised Target Date of Selection": "22-Apr-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "25-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "24-Jun-25",
        "Client": "John Deere",
        "HR name/HM": "Gaurav Kulshrestha",
        "Position Name": "Supplier Quality (Gear shaft)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 1380000,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 0,
        "Status": "closed",
        "Current delivery update": "1 L2 on hold, 1 L2 TBS",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Rushikesh Rane",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 259,
        "Position received date": "04-Apr-25",
        "Clarity call date": "07-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Reason of delay/HOLD": "Was on medical leave for 20 days",
        "Select to offer TAT": 3,
        "Approx Offer date": "25-Apr-25",
        "Official Notice Period": 60,
        "Approx DOJ": "24-Jun-25",
        "Client": "John Deere",
        "HR name/HM": "Prakash Cheliah",
        "Position Name": "Performance and Emission",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2250000,
        "Billable CTC": 1800000,
        "Commercial %": 0.07,
        "Billing amount per position": 126000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 126000.00000000001,
        "Status": "Active",
        "Current delivery update": "Live sourcinf call need to plan, 1 L1 in line",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 260,
        "Position received date": "11-Apr-25",
        "Clarity call date": "15-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "30-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "03-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "02-Jul-25",
        "Client": "John Deere",
        "HR name/HM": "Jignesh Makwana",
        "Position Name": "Labour Relations",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 1800000,
        "Commercial %": 0.07,
        "Billing amount per position": 126000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 126000.00000000001,
        "Status": "Active",
        "Current delivery update": "5 cvs to be reviewed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 261,
        "Position received date": "09-May-25",
        "Clarity call date": "13-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "28-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "31-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "30-Jul-25",
        "Client": "John Deere",
        "HR name/HM": "Ganesh",
        "Position Name": "Structure Design",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2250000,
        "Billable CTC": 1380000,
        "Commercial %": 0.07,
        "Billing amount per position": 96600.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 96600.00000000001,
        "Status": "Active",
        "Current delivery update": "1 L2 TBS, 2 L1 in line",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 262,
        "Position received date": "21-Apr-25",
        "Clarity call date": "21-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "06-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "09-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "08-Jul-25",
        "Client": "John Deere",
        "HR name/HM": "Danny Macdonald",
        "Position Name": "Physical security",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 250000,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "1 Cv FB pending",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 265,
        "Position received date": "05-May-25",
        "Clarity call date": "08-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "23-May-25",
        "Candidate Date of selection": "28-May-25",
        "Revised Target Date of Selection": "23-May-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "26-May-25",
        "Actual Offer date": "30th May'25",
        "Official Notice Period": 60,
        "Approx DOJ": "25-Jul-25",
        "Actual DOJ candidate will join": "01-Sep-25",
        "Client": "John Deere",
        "HR name/HM": "Kuldeep Dhakne",
        "Position Name": "Paintshop Automation",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1800000,
        "Billable CTC": 1409463,
        "Commercial %": 0.07,
        "Billing amount per position": 98662.41,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 98662.41,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Rahul Mandloi",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 266,
        "Position received date": "28-Apr-25",
        "Clarity call date": "30-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "15-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "18-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "17-Jul-25",
        "Client": "John Deere",
        "HR name/HM": "Mayuri Kulkarni",
        "Position Name": "DSM (Vehocle Integration)",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1950000,
        "Billable CTC": 1380000,
        "Commercial %": 0.07,
        "Billing amount per position": 96600.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 96600.00000000001,
        "Status": "Active",
        "Current delivery update": "4 L1 TBS, 2 cvs Fb pending",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 267,
        "Position received date": "06-May-25",
        "Clarity call date": "07-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-May-25",
        "Candidate Date of selection": "12-May-25",
        "Revised Target Date of Selection": "22-May-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "25-May-25",
        "Actual Offer date": "21-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "23-Aug-25",
        "Actual DOJ candidate will join": "25-Aug-25",
        "Client": "John Deere",
        "HR name/HM": "Pushkar Jog",
        "Position Name": "Supplier Quality Management",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1950000,
        "Billable CTC": 1600000,
        "Commercial %": 0.07,
        "Billing amount per position": 112000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 112000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Varun Yadav",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 268,
        "Position received date": "07-May-25",
        "Clarity call date": "07-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "29-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "28-Jul-25",
        "Client": "Agratas",
        "HR name/HM": "Pooja ",
        "Position Name": "AM Product Launch",
        "Number of Positions": 4,
        "Current Active role": 4,
        "closed": 0,
        "Budget": "16 LPA",
        "Billable CTC": 1400000,
        "Commercial %": 0.0833,
        "Billing amount per position": 1865920,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 1865920,
        "Status": "Active",
        "Current delivery update": "9 L1 to be schedule,1 cv feedback pending",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama/Ramya"
    },
    {
        "Sr.No": 269,
        "Position received date": "07-May-25",
        "Clarity call date": "07-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "29-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "28-Jul-25",
        "Client": "Agratas",
        "HR name/HM": "Pooja ",
        "Position Name": "DGM Product Launch",
        "Number of Positions": 4,
        "Current Active role": 4,
        "closed": 0,
        "Budget": "40 LPA",
        "Billable CTC": 3500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 4664800,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 4664800,
        "Status": "Active",
        "Current delivery update": "4 L1 to be schedule, 2 cvs feedback pending",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Ramya "
    },
    {
        "Sr.No": 270,
        "Position received date": "26-Mar-25",
        "Clarity call date": "31-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "15-Apr-25",
        "Candidate Date of selection": "03-Apr-25",
        "Revised Target Date of Selection": "15-Apr-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "18-Apr-25",
        "Actual Offer date": "08-Apr-25",
        "Official Notice Period": 90,
        "Approx DOJ": "17-Jul-25",
        "Actual DOJ candidate will join": "25-Aug-25",
        "Client": "John Deere",
        "HR name/HM": "Sagar Gambhir",
        "Position Name": "Cost Engineer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1950000,
        "Billable CTC": 1600000,
        "Commercial %": 0.07,
        "Billing amount per position": 112000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 112000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Akshay Sanjay Mhalunge.",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 271,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Delivery Management",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 272,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Delivery Management",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 273,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Delivery Management",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 274,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Delivery Management",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 275,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Delivery Management",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 276,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Delivery Management",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 277,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Delivery Management",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 278,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Delivery Management",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 279,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Delivery Management",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 280,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Candidate Date of selection": "20-May-25",
        "Revised Target Date of Selection": "07-May-25",
        "Reason of delay/HOLD": "6 level of interview discussion - All US rounds",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Actual Offer date": "20-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "09-Jun-25",
        "Actual DOJ candidate will join": "27-May-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Business System Analyst",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 166600,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Selected candidate name": "Sushma Ratan R",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 281,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Business System Analyst",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 282,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Business System Analyst",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 283,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Business System Analyst",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 284,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Business System Analyst",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 285,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Business System Analyst",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 286,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Business System Analyst",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 287,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "09-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Business System Analyst",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 288,
        "Position received date": "12-May-25",
        "Clarity call date": "12-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "27-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "29-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "28-Jun-25",
        "Client": "Xoriant ",
        "HR name/HM": "Abeer Raja",
        "Position Name": "L2/L3 Testing Protocols - Python",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2200000,
        "Billable CTC": 2200000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Shehnaaz",
        "Recruiter name": "Shehnaaz"
    },
    {
        "Sr.No": 289,
        "Position received date": "12-May-25",
        "Clarity call date": "12-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "27-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "29-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "28-Jun-25",
        "Client": "Xoriant ",
        "HR name/HM": "Abeer Raja",
        "Position Name": "L2/L3 Testing Protocols - Python",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2200000,
        "Billable CTC": 2200000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Shehnaaz",
        "Recruiter name": "Shehnaaz"
    },
    {
        "Sr.No": 290,
        "Position received date": "12-May-25",
        "Clarity call date": "12-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "27-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "29-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "28-Jun-25",
        "Client": "Xoriant ",
        "HR name/HM": "Abeer Raja",
        "Position Name": "L2/L3 Testing Protocols - Python",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2200000,
        "Billable CTC": 2200000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Shehnaaz",
        "Recruiter name": "Shehnaaz"
    },
    {
        "Sr.No": 291,
        "Position received date": "12-May-25",
        "Clarity call date": "12-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "27-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "29-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "28-Jun-25",
        "Client": "Xoriant ",
        "HR name/HM": "Abeer Raja",
        "Position Name": "L2/L3 Testing Protocols - Python",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2200000,
        "Billable CTC": 2200000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Shehnaaz",
        "Recruiter name": "Shehnaaz"
    },
    {
        "Sr.No": 292,
        "Position received date": "12-May-25",
        "Clarity call date": "12-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "27-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "29-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "28-Jun-25",
        "Client": "Xoriant ",
        "HR name/HM": "Abeer Raja",
        "Position Name": "L2/L3 Testing Protocols - Python",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2200000,
        "Billable CTC": 2200000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Shehnaaz",
        "Recruiter name": "Shehnaaz"
    },
    {
        "Sr.No": 293,
        "Position received date": "12-May-25",
        "Clarity call date": "12-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "27-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "29-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "28-Jul-25",
        "Client": "Xoriant",
        "HR name/HM": "Abeer Raja",
        "Position Name": "L2/L3 Testing Protocols - Python",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2400000,
        "Billable CTC": 2200000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 294,
        "Position received date": "28-Apr-25",
        "Clarity call date": "28-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "03-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "05-May-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Java Cucumber",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 3100000,
        "Billable CTC": 3100000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 295,
        "Position received date": "28-Apr-25",
        "Clarity call date": "28-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "15-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "QA Playwright, Typescript, Performance testing(4-6 Yrs)",
        "Number of Positions": 2,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 296,
        "Position received date": "28-Apr-25",
        "Clarity call date": "28-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "15-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "QA Playwright, Typescript, Performance testing(6-8 Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 297,
        "Position received date": "28-Apr-25",
        "Clarity call date": "28-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "15-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Playwright, Gatling(6-8Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 298,
        "Position received date": "28-Apr-25",
        "Clarity call date": "28-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "15-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Playwright, Gatling(6-8Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 299,
        "Position received date": "28-Apr-25",
        "Clarity call date": "28-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "13-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "15-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "14-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Python Devops Automation(4-6 Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 300,
        "Position received date": "23-Apr-25",
        "Clarity call date": "23-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "09-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Lua/Kong API Gateway(2-4 Yrs)",
        "Number of Positions": 2,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 301,
        "Position received date": "23-Apr-25",
        "Clarity call date": "23-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "09-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Lua/Kong API Gateway(4-6 Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 302,
        "Position received date": "23-Apr-25",
        "Clarity call date": "23-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "09-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Lua/Kong API Gateway(6-8Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2500000,
        "Billable CTC": 2500000,
        "Commercial %": 0.075,
        "Billing amount per position": 187500,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 187500,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Selected candidate name": "Viraj kadam",
        "Recruiter name": "Megha"
    },
    {
        "Sr.No": 303,
        "Position received date": "23-Apr-25",
        "Clarity call date": "23-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "08-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "10-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "09-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Lua/Kong API Gateway(6-8Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 304,
        "Position received date": "14-May-25",
        "Clarity call date": "14-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "29-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "31-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "30-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Java Cucumber(9-10 Yrs)",
        "Number of Positions": 2,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 4200000,
        "Billable CTC": 4200000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 305,
        "Position received date": "14-May-25",
        "Clarity call date": "14-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "29-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "31-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "30-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Java FS AWS(6-8 Yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 306,
        "Position received date": "14-May-25",
        "Clarity call date": "14-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "29-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "31-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "30-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Python  SQL(6-8yrs)",
        "Number of Positions": 2,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 307,
        "Position received date": "14-May-25",
        "Clarity call date": "14-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "29-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "31-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "30-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Python  SQL(8-10 yrs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 308,
        "Position received date": "14-May-25",
        "Clarity call date": "14-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "29-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "31-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "30-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Java NodeJS(4-6 rs)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 309,
        "Position received date": "21-May-25",
        "Clarity call date": "21-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "05-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "12-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "10-Sep-25",
        "Client": "Agratas",
        "HR name/HM": "Pankaj Kajal",
        "Position Name": "GM Legal",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "65LPA",
        "Billable CTC": 5300000,
        "Commercial %": 0.12,
        "Billing amount per position": 636000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 636000,
        "Status": "Active",
        "Current delivery update": "1 L2 to be schedule, 3 cvs feedback penidng",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Ramya "
    },
    {
        "Sr.No": 310,
        "Position received date": "15-May-25",
        "Clarity call date": "16-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "31-May-25",
        "Candidate Date of selection": "28-May-25",
        "Revised Target Date of Selection": "31-May-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "07-Jun-25",
        "Actual Offer date": "03-Jun-25",
        "Official Notice Period": 15,
        "Approx DOJ": "22-Jun-25",
        "Actual DOJ candidate will join": "25-Jun-25",
        "Client": "Agratas",
        "HR name/HM": "Pratiksha Ojha",
        "Position Name": "Process Engineering – Powder Handling & Dosage (equipment - Cathode & Anode)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": "18 LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 124950,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 124950,
        "Status": "Closed",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Selected candidate name": "Ravindra Ghodake",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 311,
        "Position received date": "15-May-25",
        "Clarity call date": "16-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "31-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "07-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "05-Sep-25",
        "Client": "Agratas",
        "HR name/HM": "Pratiksha Ojha",
        "Position Name": "Deputy General Manager – Process safety and Equipment",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": "40 LPA",
        "Billable CTC": 3200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 266560,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 266560,
        "Status": "Active",
        "Current delivery update": "Need to serve",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Disha"
    },
    {
        "Sr.No": 312,
        "Position received date": "15-May-25",
        "Clarity call date": "16-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "31-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "07-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "05-Sep-25",
        "Client": "Agratas",
        "HR name/HM": "Pratiksha Ojha",
        "Position Name": "Contamination Control Lead",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "18 LPA",
        "Billable CTC": 1500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "3 cvs feedback pending",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 313,
        "Position received date": "15-May-25",
        "Clarity call date": "16-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "31-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "31-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "29-Aug-25",
        "Client": "Agratas",
        "HR name/HM": "Pratiksha Ojha",
        "Position Name": "Process Engineer- Slot Die Coating (process – Cathode & Anode)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "40 LPA",
        "Billable CTC": 3200000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "Need to serve",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 314,
        "Position received date": "21-May-25",
        "Clarity call date": "16-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "31-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "07-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "05-Sep-25",
        "Client": "Agratas",
        "HR name/HM": "Pankaj Kajal",
        "Position Name": "GM Plant Launch",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": "65LPA",
        "Billable CTC": 5300000,
        "Commercial %": 0.12,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Current delivery update": "2cvs feedback pending",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama"
    },
    {
        "Sr.No": 315,
        "Position received date": "20-May-25",
        "Clarity call date": "20-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "04-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "06-Jun-25",
        "Official Notice Period": 30,
        "Approx DOJ": "06-Jul-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "Devops (6-8 Years)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha Patel",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 316,
        "Position received date": "10-May-25",
        "Clarity call date": "10-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "25-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "27-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "26-Jun-25",
        "Client": "Xoriant",
        "HR name/HM": "Suchi Agarwal",
        "Position Name": "React JS (6-8 years)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2700000,
        "Billable CTC": 2700000,
        "Commercial %": 0.075,
        "Billing amount per position": 202500,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 202500,
        "Status": "Closed",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Selected candidate name": "Rohit Sawai",
        "Recruiter name": "Monika"
    },
    {
        "Sr.No": 317,
        "Position received date": "21-May-25",
        "Clarity call date": "21-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "05-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "07-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "05-Sep-25",
        "Client": "LNT",
        "HR name/HM": "Betty/Tarun",
        "Position Name": "AC design (Solar)",
        "Number of Positions": 3,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 1400000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 318,
        "Position received date": "21-May-25",
        "Clarity call date": "21-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "05-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "07-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "05-Sep-25",
        "Client": "LNT",
        "HR name/HM": "Betty/Tarun",
        "Position Name": "DC design (Solar)",
        "Number of Positions": 2,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 1400000,
        "Commercial %": 0.0833,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran"
    },
    {
        "Sr.No": 319,
        "Position received date": "26-Mar-25",
        "Clarity call date": "31-Mar-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "15-Apr-25",
        "Candidate Date of selection": "15-Apr-25",
        "Revised Target Date of Selection": "15-Apr-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "18-Apr-25",
        "Actual Offer date": "08-Apr-25",
        "Official Notice Period": 90,
        "Approx DOJ": "17-Jul-25",
        "Actual DOJ candidate will join": "25-Aug-25",
        "Client": "John Deere",
        "HR name/HM": "Sagar Gambhir",
        "Position Name": "Cost Engineer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1601036,
        "Billable CTC": 1510411,
        "Commercial %": 0.07,
        "Billing amount per position": 105728.77,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 105728.77,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Selected candidate name": "Sagar Rameshwar Pore",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Sr.No": 320,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "07-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "06-Jul-25",
        "Client": "John Deere",
        "HR name/HM": "Vishal rane",
        "Position Name": "Sr engineer CVML(11294)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2000000,
        "Billable CTC": 1800000,
        "Commercial %": 0.07,
        "Billing amount per position": 126000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 126000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Nikhil dhayakar",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 321,
        "Position received date": "05-Apr-25",
        "Clarity call date": "05-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Apr-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "08-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "07-Jul-25",
        "Client": "L&T Defence",
        "HR name/HM": "kalpesh",
        "Position Name": "Sr software engineer - C++/QT",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1300000,
        "Billable CTC": 1300000,
        "Commercial %": 0.0833,
        "Billing amount per position": 108290,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 108290,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Rasheed",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 322,
        "Position received date": "25-May-25",
        "Clarity call date": "25-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "09-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "12-Jun-25",
        "Actual Offer date": "29-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "12-Jul-25",
        "Client": "L&T Defence",
        "HR name/HM": "kalpesh",
        "Position Name": "Sr software engineer - C++/QT",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1100000,
        "Billable CTC": 1100000,
        "Commercial %": 0.0833,
        "Billing amount per position": 91630,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 91630,
        "Status": "Active",
        "Current delivery update": "2CV FP and 1 L1 In line(need to add CV)",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 323,
        "Position received date": "15-May-25",
        "Clarity call date": "15-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "30-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "02-Jun-25",
        "Official Notice Period": 60,
        "Approx DOJ": "01-Aug-25",
        "Client": "L&T Defence",
        "HR name/HM": "Kalpesh",
        "Position Name": "Software documentation",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1100000,
        "Billable CTC": 1100000,
        "Commercial %": 0.0833,
        "Billing amount per position": 91630,
        "Business Ensurity  (100/75/50/25) -%": 0.5,
        "Business Ensurity (actual revenue)": 45815,
        "Status": "Active",
        "Current delivery update": "1 Final Hold",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Sriram",
        "Selected candidate name": "Aishwarya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 324,
        "Position received date": "22-Apr-25",
        "Clarity call date": "22-Apr-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "11-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "10-Jul-25",
        "Client": "Zeta Global",
        "HR name/HM": "Sangeeta Madaka",
        "Position Name": "Business System Analyst",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 166600,
        "Business Ensurity  (100/75/50/25) -%": 0.25,
        "Business Ensurity (actual revenue)": 41650,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Bhagya",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 325,
        "Position received date": "26-May-25",
        "Clarity call date": "26-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "10-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "12-May-25",
        "Official Notice Period": 60,
        "Approx DOJ": "11-Jul-25",
        "Client": "Agratas",
        "HR name/HM": "Sonali Phalke",
        "Position Name": "Data Architect",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 4500000,
        "Billable CTC": 3800000,
        "Commercial %": 0.0833,
        "Billing amount per position": 316540,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 316540,
        "Status": "Active",
        "Current delivery update": "1 L2 to be schedule, 4 cvs feedback pending",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Sriram/Shehnaaz"
    },
    {
        "Sr.No": 326,
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-00",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "13-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "11-Aug-25",
        "Client": "Ramky",
        "HR name/HM": "Sarvotham/Bipin Patel",
        "Position Name": "Project Manager",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2000000,
        "Billable CTC": 2000000,
        "Commercial %": 0.1,
        "Billing amount per position": 200000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 200000,
        "Status": "Active",
        "Internal SPOC": "Aashi"
    },
    {
        "Sr.No": 327,
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-00",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "14-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "12-Aug-25",
        "Client": "Ramky",
        "HR name/HM": "Sarvotham/Bipin Patel",
        "Position Name": "Civil Engineer",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1000000,
        "Billable CTC": 1000000,
        "Commercial %": 0.1,
        "Billing amount per position": 100000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 100000,
        "Status": "Active",
        "Internal SPOC": "Aashi"
    },
    {
        "Sr.No": 328,
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-00",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "11-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "09-Aug-25",
        "Client": "Ramky",
        "HR name/HM": "Sarvotham/Bipin Patel",
        "Position Name": "CRM Manager",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1000000,
        "Billable CTC": 1000000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Aashi"
    },
    {
        "Sr.No": 329,
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-00",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "12-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "10-Aug-25",
        "Client": "Ramky",
        "HR name/HM": "Sarvotham/Bipin Patel",
        "Position Name": "Sales Manager",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2000000,
        "Billable CTC": 2000000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Aashi"
    },
    {
        "Sr.No": 330,
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-00",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "13-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "11-Aug-25",
        "Client": "Ramky",
        "HR name/HM": "Sarvotham/Bipin Patel",
        "Position Name": "QA/QC Manager",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1000000,
        "Billable CTC": 1000000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Aashi"
    },
    {
        "Sr.No": 331,
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-00",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "14-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "12-Aug-25",
        "Client": "Ramky",
        "HR name/HM": "Sarvotham/Bipin Patel",
        "Position Name": "MEP Engineer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1000000,
        "Billable CTC": 1000000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Aashi"
    },
    {
        "Sr.No": 332,
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "14-Jan-00",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "15-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "13-Aug-25",
        "Client": "Ramky",
        "HR name/HM": "Sarvotham/Bipin Patel",
        "Position Name": "Billing Engineer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1000000,
        "Billable CTC": 1000000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Aashi"
    },
    {
        "Sr.No": 333,
        "Position received date": "05-Sep-25",
        "Clarity call date": "05-Sep-25",
        "Position renew date": "05-Sep-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Sep-25",
        "Revised Target Date of Selection": "20-Sep-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "16-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "14-Aug-25",
        "Client": "Ramky",
        "HR name/HM": "Sarvotham/Bipin Patel",
        "Position Name": "Front Desk Executive",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 700000,
        "Billable CTC": 700000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Aashi",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 334,
        "Position received date": "05-Sep-25",
        "Clarity call date": "05-Sep-25",
        "Position renew date": "05-Sep-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Sep-25",
        "Revised Target Date of Selection": "20-Sep-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "15-Aug-25",
        "Client": "Ramky",
        "HR name/HM": "Sarvotham/Bipin Patel",
        "Position Name": "Sr.Planning Engineer",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1000000,
        "Billable CTC": 1000000,
        "Commercial %": 0.1,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Internal SPOC": "Aashi",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 335,
        "Position received date": "15-Feb-25",
        "Clarity call date": "15-Feb-25",
        "Position renew date": "15-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "15-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "13-Aug-25",
        "Client": "Godrej",
        "HR name/HM": "Antara/Surabhi Kapur",
        "Position Name": "Manager - Legal Litigation",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2600000,
        "Billable CTC": 2600000,
        "Commercial %": 0.07,
        "Billing amount per position": 182000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 182000.00000000003,
        "Status": "Closed",
        "Current delivery update": "Offer is in process",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Aashi",
        "Selected candidate name": "Veera Mathai",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 336,
        "Position received date": "15-Feb-25",
        "Clarity call date": "15-Feb-25",
        "Position renew date": "15-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "16-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "19-May-25",
        "Actual DOJ candidate will join": "21-May-25",
        "Client": "Godrej",
        "HR name/HM": "Antara/Tushar Garg",
        "Position Name": "Site Finance TL - Kurukshetra",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2100000,
        "Billable CTC": 2100000,
        "Commercial %": 0.07,
        "Billing amount per position": 147000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 147000,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Aashi",
        "Selected candidate name": "Mohd Arif",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 337,
        "Position received date": "15-Feb-25",
        "Clarity call date": "15-Feb-25",
        "Position renew date": "15-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "17-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "15-Aug-25",
        "Client": "Godrej",
        "HR name/HM": "Antara/Niharika Yadav",
        "Position Name": "SM Design - RO - NCR 1",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 3500000,
        "Billable CTC": 3500000,
        "Commercial %": 0.07,
        "Billing amount per position": 245000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 245000.00000000003,
        "Status": "Closed",
        "Current delivery update": "Offer is in process",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Aashi",
        "Selected candidate name": "Nikhil Jain",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 338,
        "Position received date": "15-Feb-25",
        "Clarity call date": "15-Feb-25",
        "Position renew date": "15-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "18-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "16-Aug-25",
        "Client": "Godrej",
        "HR name/HM": "Antara/Divya Jha",
        "Position Name": "Manager HRBP (Divya)",
        "Number of Positions": 2,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2000000,
        "Billable CTC": 2000000,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Aashi",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 339,
        "Position received date": "15-Feb-25",
        "Clarity call date": "15-Feb-25",
        "Position renew date": "15-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "19-May-25",
        "Official Notice Period": 30,
        "Approx DOJ": "18-Jun-25",
        "Actual DOJ candidate will join": "02-Jun-25",
        "Client": "Godrej",
        "HR name/HM": "Antara/Shilpa Tarkar",
        "Position Name": "Sr. Executive - Accounts",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 1000000,
        "Billable CTC": 1000000,
        "Commercial %": 0.07,
        "Billing amount per position": 70000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 70000,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Aashi",
        "Selected candidate name": "Rupesh Amberkar",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 340,
        "Position received date": "15-Feb-25",
        "Clarity call date": "15-Feb-25",
        "Position renew date": "15-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "20-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "18-Aug-25",
        "Client": "Godrej",
        "HR name/HM": "Antara/Anusha",
        "Position Name": "Talent Aquisition Specialist (COE)",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 1500000,
        "Billable CTC": 1500000,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Aashi",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 341,
        "Position received date": "15-Feb-25",
        "Clarity call date": "15-Feb-25",
        "Position renew date": "15-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "24-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "22-Aug-25",
        "Client": "Godrej",
        "HR name/HM": "Antara/Vivek Sharma",
        "Position Name": "Manager Sales-Retail",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 0,
        "Budget": 2500000,
        "Billable CTC": 2500000,
        "Commercial %": 0.07,
        "Billing amount per position": 0,
        "Business Ensurity  (100/75/50/25) -%": 0,
        "Business Ensurity (actual revenue)": 0,
        "Status": "HOLD",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Aashi",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 342,
        "Position received date": "15-Feb-25",
        "Clarity call date": "15-Feb-25",
        "Position renew date": "15-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "21-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "19-Aug-25",
        "Actual DOJ candidate will join": "15-May-25",
        "Client": "Godrej",
        "HR name/HM": "Angtara/Shilpa Tarkar",
        "Position Name": "Executive Accounts",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 700000,
        "Billable CTC": 700000,
        "Commercial %": 0.07,
        "Billing amount per position": 49000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 49000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Aashi",
        "Selected candidate name": "Swanand Kabadi",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 343,
        "Position received date": "15-Feb-25",
        "Clarity call date": "15-Feb-25",
        "Position renew date": "15-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "22-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "20-Aug-25",
        "Actual DOJ candidate will join": "19-May-25",
        "Client": "Godrej",
        "HR name/HM": "Antara Sawant",
        "Position Name": "MIS-TA",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 700000,
        "Billable CTC": 700000,
        "Commercial %": 0.07,
        "Billing amount per position": 49000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 49000.00000000001,
        "Status": "Closed",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Aashi",
        "Selected candidate name": "Vishnu Sreenivasan",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 344,
        "Position received date": "15-Feb-25",
        "Clarity call date": "15-Feb-25",
        "Position renew date": "15-Feb-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "02-Mar-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 7,
        "Approx Offer date": "23-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "21-Aug-25",
        "Client": "Godrej",
        "HR name/HM": "Srushti/Pooja Shetty",
        "Position Name": "Manager Finance Consolidation",
        "Number of Positions": 1,
        "Current Active role": 0,
        "closed": 1,
        "Budget": 2600000,
        "Billable CTC": 2600000,
        "Commercial %": 0.07,
        "Billing amount per position": 182000.00000000003,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 182000.00000000003,
        "Status": "Closed",
        "Current delivery update": "Offer in process",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Aashi",
        "Selected candidate name": "Chirag Shetty",
        "Recruiter name": "Aashi"
    },
    {
        "Sr.No": 345,
        "Position received date": "25-May-25",
        "Clarity call date": "25-May-25",
        "Position renew date": "25-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "09-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "12-Jun-25",
        "Official Notice Period": 30,
        "Approx DOJ": "12-Jul-25",
        "Client": "L&T Defence",
        "HR name/HM": "kalpesh",
        "Position Name": "Sr software engineer - C++/QT",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1100000,
        "Billable CTC": 1100000,
        "Commercial %": 0.0833,
        "Billing amount per position": 91630,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 91630,
        "Status": "Active",
        "Current delivery update": "2CV FP and 1 L1 In line(need to add CV)",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Sr.No": 346,
        "Position received date": "25-May-25",
        "Clarity call date": "25-May-25",
        "Position renew date": "25-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "09-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "12-Jun-25",
        "Official Notice Period": 30,
        "Approx DOJ": "12-Jul-25",
        "Client": "L&T Defence",
        "HR name/HM": "kalpesh",
        "Position Name": "Sr software engineer - C++/QT",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1100000,
        "Billable CTC": 1100000,
        "Commercial %": 0.0833,
        "Billing amount per position": 91630,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 91630,
        "Status": "Active",
        "Current delivery update": "2CV FP and 1 L1 In line(need to add CV)",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Priyanka"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "26-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "24-Aug-25",
        "Client": "LTTS",
        "HR name/HM": "Ashwini Kudi",
        "Position Name": "Python Azure Engineer",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "27-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "25-Aug-25",
        "Client": "LTTS",
        "HR name/HM": "Ashwini Kudi",
        "Position Name": "Python Azure Lead",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "28-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "26-Aug-25",
        "Client": "LTTS",
        "HR name/HM": "Ashwini Kudi",
        "Position Name": "Java-Azure",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "29-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "27-Aug-25",
        "Client": "LTTS",
        "HR name/HM": "Ashwini Kudi",
        "Position Name": "Java-Azure",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "30-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "28-Aug-25",
        "Client": "LTTS",
        "HR name/HM": "Ashwini Kudi",
        "Position Name": "Databricks SME",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "31-May-25",
        "Official Notice Period": 90,
        "Approx DOJ": "29-Aug-25",
        "Client": "LTTS",
        "HR name/HM": "Ashwini Kudi",
        "Position Name": "UI/UX Data Expert",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "01-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "30-Aug-25",
        "Client": "LTTS",
        "HR name/HM": "Ashwini Kudi",
        "Position Name": "OKTA Specialist",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "02-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "31-Aug-25",
        "Client": "LTTS",
        "HR name/HM": "Ashwini Kudi",
        "Position Name": "Data Architect",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "03-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "01-Sep-25",
        "Client": "LTTS",
        "HR name/HM": "Ashwini Kudi",
        "Position Name": "Java Full Stack -Angular",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "04-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "02-Sep-25",
        "Client": "LTTS",
        "HR name/HM": "Ashwini Kudi",
        "Position Name": "Java Backend with HL7",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "05-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "03-Sep-25",
        "Client": "LTTS",
        "HR name/HM": "Naveen/Harini",
        "Position Name": "MES Consultant",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "06-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "04-Sep-25",
        "Client": "LTTS",
        "HR name/HM": "Naveen/Harini",
        "Position Name": "MES Architect",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "07-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "05-Sep-25",
        "Client": "LTTS",
        "HR name/HM": "Naveen/Harini",
        "Position Name": "CM Developer",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "08-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "06-Sep-25",
        "Client": "LTTS",
        "HR name/HM": "Naveen/Harini",
        "Position Name": "Ignition Developer",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "23-May-25",
        "Clarity call date": "23-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "07-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Approx Offer date": "09-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "07-Sep-25",
        "Client": "LTTS",
        "HR name/HM": "Naveen/Harini",
        "Position Name": "Ignition Architect",
        "Status": "Active",
        "Payment terms ( in days)": 90,
        "Internal SPOC": "Megha",
        "Recruiter name": "Monika"
    },
    {
        "Position received date": "15-May-25",
        "Clarity call date": "15-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "30-May-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "01-Jun-25",
        "Official Notice Period": 60,
        "Approx DOJ": "31-Jul-25",
        "Client": "John Deere",
        "HR name/HM": "Santosh Shelake",
        "Position Name": "Manufacturing Engineer",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 1400000,
        "Commercial %": 0.07,
        "Billing amount per position": 98000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 98000.00000000001,
        "Status": "Active",
        "Current delivery update": "1 L1 TBS",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Position received date": "22-May-25",
        "Clarity call date": "27-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "11-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "13-Jun-25",
        "Official Notice Period": 60,
        "Approx DOJ": "12-Aug-25",
        "Client": "John Deere",
        "HR name/HM": "Amit Patil",
        "Position Name": "Instrumentation and Control",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2200000,
        "Billable CTC": 1600000,
        "Commercial %": 0.07,
        "Billing amount per position": 112000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 112000.00000000001,
        "Status": "Active",
        "Current delivery update": "1 L1 in line",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Position received date": "28-May-25",
        "Clarity call date": "28-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "14-Jun-25",
        "Official Notice Period": 60,
        "Approx DOJ": "13-Aug-25",
        "Client": "John Deere",
        "HR name/HM": "Abhishek Kumar (PY)",
        "Position Name": "Transmission Machine Shop",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 1400000,
        "Commercial %": 0.07,
        "Billing amount per position": 98000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 98000.00000000001,
        "Status": "Active",
        "Current delivery update": "3 L1 in line",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran"
    },
    {
        "Position received date": "28-May-25",
        "Clarity call date": "28-May-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "12-Jun-25",
        "Revised Target Date of Selection": "13-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "14-Jun-25",
        "Official Notice Period": 60,
        "Approx DOJ": "13-Aug-25",
        "Client": "John Deere",
        "HR name/HM": "Nilesh Aware",
        "Position Name": "Facility",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 2200000,
        "Billable CTC": 1600000,
        "Commercial %": 0.07,
        "Billing amount per position": 112000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 112000.00000000001,
        "Status": "Active",
        "Current delivery update": "2 L2 in line",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Position received date": "29-May-25",
        "Clarity call date": "03-Jun-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "18-Jun-25",
        "Revised Target Date of Selection": "18-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "20-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "18-Sep-25",
        "Client": "John Deere",
        "HR name/HM": "Nishant Shah",
        "Position Name": "Operator Station",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 1400000,
        "Commercial %": 0.07,
        "Billing amount per position": 98000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 98000.00000000001,
        "Status": "Active",
        "Current delivery update": "4 cvs FB pending",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran"
    },
    {
        "Position received date": "05-Jun-25",
        "Clarity call date": "09-Jun-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "24-Jun-25",
        "Revised Target Date of Selection": "24-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "26-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "24-Sep-25",
        "Client": "John Deere",
        "HR name/HM": "Sameer Mane",
        "Position Name": "Warehouse",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 1400000,
        "Commercial %": 0.07,
        "Billing amount per position": 98000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 98000.00000000001,
        "Status": "Active",
        "Current delivery update": "4 cvs FB pending",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Charul Sharma"
    },
    {
        "Position received date": "11-Jun-25",
        "Clarity call date": "11-Jun-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "26-Jun-25",
        "Revised Target Date of Selection": "26-Jun-25",
        "Select to offer TAT": 2,
        "Approx Offer date": "28-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "26-Sep-25",
        "Client": "John Deere",
        "HR name/HM": "Ganesh jadhav",
        "Position Name": "Vehicle Maintenance",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1800000,
        "Billable CTC": 1400000,
        "Commercial %": 0.07,
        "Billing amount per position": 98000.00000000001,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 98000.00000000001,
        "Status": "Active",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Charul Sharma",
        "Recruiter name": "Simran"
    },
    {
        "Position received date": "06-Jun-25",
        "Clarity call date": "11-Jun-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "26-Jun-25",
        "Revised Target Date of Selection": "26-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "01-Jul-25",
        "Official Notice Period": 90,
        "Approx DOJ": "29-Sep-25",
        "Client": "Agratas",
        "HR name/HM": "Shivam Konwar",
        "Position Name": "DGM Quality",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 4200000,
        "Billable CTC": 3500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 291550,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 291550,
        "Status": "Active",
        "Current delivery update": "Need to serve",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Ramya /Disha"
    },
    {
        "Position received date": "06-Jun-25",
        "Clarity call date": "06-Jun-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "21-Jun-25",
        "Revised Target Date of Selection": "21-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "26-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "24-Sep-25",
        "Client": "Agratas",
        "HR name/HM": "Pankaj Kajal",
        "Position Name": "HOD Production-GM",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 7500000,
        "Billable CTC": 6500000,
        "Commercial %": 0.12,
        "Billing amount per position": 780000,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 780000,
        "Status": "Active",
        "Current delivery update": "2 L1 in line, 1 cv feedback pending",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Anupama"
    },
    {
        "Position received date": "05-Jun-25",
        "Clarity call date": "05-Jun-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "20-Jun-25",
        "Revised Target Date of Selection": "20-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "25-Jun-25",
        "Official Notice Period": 90,
        "Approx DOJ": "23-Sep-25",
        "Client": "Agratas",
        "HR name/HM": "Sinku Lama",
        "Position Name": "AM Packaging Position",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1700000,
        "Billable CTC": 1500000,
        "Commercial %": 0.0833,
        "Billing amount per position": 124950,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 124950,
        "Status": "Active",
        "Current delivery update": "Need to serve",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Anupama",
        "Recruiter name": "Ramya"
    },
    {
        "Position received date": "09-Jun-25",
        "Clarity call date": "11-Jun-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "26-Jun-25",
        "Revised Target Date of Selection": "26-Jun-25",
        "Select to offer TAT": 5,
        "Approx Offer date": "01-Jul-25",
        "Official Notice Period": 60,
        "Approx DOJ": "30-Aug-25",
        "Client": "Brembo brakes",
        "HR name/HM": "Khalid Pathan",
        "Position Name": "Process Engineering",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1000000,
        "Billable CTC": 1000000,
        "Commercial %": 0.0833,
        "Billing amount per position": 83300,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 83300,
        "Status": "Active",
        "Current delivery update": "Need to serve",
        "Payment terms ( in days)": 30,
        "Internal SPOC": "Anupama"
    },
    {
        "Clarity call date": "07-Jun-25",
        "Position renew date": "07-Jun-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Jun-25",
        "Revised Target Date of Selection": "22-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "25-Jun-25",
        "Official Notice Period": 30,
        "Approx DOJ": "25-Jul-25",
        "Client": "L&T Defence",
        "HR name/HM": "kalpesh",
        "Position Name": "Software Engineer(ADAS)",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1100000,
        "Billable CTC": 1100000,
        "Commercial %": 0.0833,
        "Billing amount per position": 91630,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 91630,
        "Status": "Active",
        "Current delivery update": "6 L1 in line",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Sriram"
    },
    {
        "Clarity call date": "07-Jun-25",
        "Position renew date": "07-Jun-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "22-Jun-25",
        "Revised Target Date of Selection": "22-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "25-Jun-25",
        "Official Notice Period": 30,
        "Approx DOJ": "25-Jul-25",
        "Client": "L&T Defence",
        "HR name/HM": "kalpesh",
        "Position Name": "Software Engineer(ADAS)",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 1100000,
        "Billable CTC": 1100000,
        "Commercial %": 0.0833,
        "Billing amount per position": 91630,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 91630,
        "Status": "Active",
        "Current delivery update": "6 L1 in line",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Sriram"
    },
    {
        "Clarity call date": "02-Jun-25",
        "Position renew date": "02-Jun-25",
        "TAT to selection as per SLA": 15,
        "Target Date of Selection": "17-Jun-25",
        "Revised Target Date of Selection": "17-Jun-25",
        "Select to offer TAT": 3,
        "Approx Offer date": "20-Jun-25",
        "Official Notice Period": 30,
        "Approx DOJ": "20-Jul-25",
        "Client": "L&T Defence",
        "HR name/HM": "Namratha",
        "Position Name": "Softwar Engineer C++ / QT",
        "Number of Positions": 1,
        "Current Active role": 1,
        "closed": 0,
        "Budget": 700000,
        "Billable CTC": 700000,
        "Commercial %": 0.0833,
        "Billing amount per position": 58310,
        "Business Ensurity  (100/75/50/25) -%": 1,
        "Business Ensurity (actual revenue)": 58310,
        "Status": "Active",
        "Current delivery update": "3 L1 Inline",
        "Payment terms ( in days)": 45,
        "Internal SPOC": "Sriram",
        "Recruiter name": "Sriram"
    }
]